interface Props {
  active?: boolean
  width?: number
  height?: number
}
export const BookMark = () => {
  return (
    <svg
      width={24}
      height={33}
      viewBox='0 0 24 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.5 15H16.5M7.5 21H16.5M7.5 9H16.5M1.5 3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H21C21.3978 1.5 21.7794 1.65804 22.0607 1.93934C22.342 2.22064 22.5 2.60218 22.5 3V31.5L17.25 27.75L12 31.5L6.75 27.75L1.5 31.5V3Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const AddToCart = () => {
  return (
    <svg
      width={23}
      height={22}
      viewBox='0 0 23 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.0315 2.04944C21.5191 1.40899 20.6225 1.02472 19.7259 1.02472H18.8292C18.3169 1.02472 17.9326 1.40899 17.9326 1.92135C17.9326 2.43371 18.3169 2.81797 18.8292 2.81797H19.7259C19.982 2.81797 20.2382 2.94607 20.4944 3.20225C20.6225 3.45843 20.7506 3.7146 20.7506 3.97078L19.2135 11.1438C19.0854 11.6562 18.7011 11.9124 18.3169 11.9124H8.58204C8.06968 11.9124 7.68539 11.6562 7.68539 11.1438L5.63598 0.768537C5.50789 0.256178 5.12361 0 4.73934 0H0.896645C0.384285 0 0 0.384266 0 0.896625C0 1.40898 0.384285 1.79326 0.896645 1.79326H3.97079L5.89214 11.4C6.14832 12.6809 7.30115 13.7056 8.71013 13.7056H18.445C19.854 13.7056 21.0067 12.809 21.2629 11.4L22.8 4.22697C22.8 3.71461 22.5438 2.81798 22.0315 2.04944Z'
        fill='white'
      />
      <path
        d='M10.3755 15.627C9.3508 15.2427 8.06991 15.3708 7.30137 16.2674C6.53283 17.036 6.27665 18.3169 6.66092 19.3416C7.04519 20.3663 8.19801 21.1348 9.35082 21.1348C10.8879 21.1348 12.1688 19.854 12.1688 18.3169C12.0407 17.036 11.4002 16.0112 10.3755 15.627ZM9.60697 19.0854C9.2227 19.2135 8.83845 19.2135 8.58227 18.8292C8.32609 18.573 8.19798 18.1888 8.32607 17.8045C8.45416 17.4202 8.83845 17.1641 9.22272 17.1641C9.73508 17.1641 10.1194 17.5483 10.1194 18.0607C10.2475 18.573 9.99124 18.9573 9.60697 19.0854Z'
        fill='white'
      />
      <path
        d='M18.9576 15.627C17.9328 15.2427 16.6519 15.3708 15.8834 16.2674C15.1149 17.036 14.8587 18.3169 15.243 19.3416C15.6272 20.3663 16.78 21.1348 17.9328 21.1348C19.4699 21.1348 20.7508 19.854 20.7508 18.3169C20.7508 17.036 19.9823 16.0112 18.9576 15.627ZM18.189 19.0854C17.8047 19.2135 17.4205 19.2135 17.1643 18.8292C16.9081 18.573 16.78 18.1888 16.9081 17.8045C17.0362 17.4202 17.4205 17.1641 17.8047 17.1641C18.3171 17.1641 18.7014 17.5483 18.7014 18.0607C18.8294 18.573 18.5733 18.9573 18.189 19.0854Z'
        fill='white'
      />
      <path
        d='M10.2473 6.78873H12.1687V8.71008C12.1687 9.22244 12.553 9.60671 13.0653 9.60671C13.5777 9.60671 13.962 9.22244 13.962 8.71008V6.78873H15.8833C16.3957 6.78873 16.7799 6.40446 16.7799 5.8921C16.7799 5.37974 16.3957 4.99547 15.8833 4.99547H13.962V3.07413C13.962 2.56177 13.5777 2.17749 13.0653 2.17749C12.553 2.17749 12.1687 2.56177 12.1687 3.07413V4.99547H10.2473C9.73496 4.99547 9.35072 5.37974 9.35072 5.8921C9.22263 6.40446 9.60687 6.78873 10.2473 6.78873Z'
        fill='white'
      />
    </svg>
  )
}
export const Polygon = () => {
  return (
    <svg
      className='ml-[15px] border border-dark-100 shadow-none outline-none'
      width='22'
      height='22'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 10L12 14L8 10'
        stroke='#161616'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export const IconBack = () => {
  return (
    <svg
      width={12}
      height={20}
      viewBox='0 0 12 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2.91414L9.7166 0.681641L0 10.1816L9.7166 19.6816L12 17.4491L4.583 10.1816L12 2.91414Z'
        fill='#555555'
      />
    </svg>
  )
}
export const Bep = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1_10101)'>
        <path
          d='M23 8H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M16 23H4C2.343 23 1 21.657 1 20V8H19V20C19 21.657 17.657 23 16 23Z'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M1 13H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M10 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M5 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M15 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_10101'>
          <rect width={24} height={24} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const RuaBat = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconHome = () => {
  return (
    <svg
      width={23}
      height={24}
      viewBox='0 0 23 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.2787 23.6788H6.72043C5.6395 23.719 4.5864 23.3309 3.78994 22.5991C2.99348 21.8672 2.51801 20.8506 2.46683 19.7701V14.6461C2.46683 14.4283 2.55335 14.2194 2.70734 14.0654C2.86134 13.9114 3.0702 13.8249 3.28799 13.8249C3.50577 13.8249 3.71464 13.9114 3.86864 14.0654C4.02263 14.2194 4.10915 14.4283 4.10915 14.6461V19.7701C4.15962 20.4151 4.46178 21.0143 4.95037 21.4384C5.43896 21.8624 6.07476 22.0773 6.72043 22.0365H16.2787C16.9244 22.0773 17.5602 21.8624 18.0488 21.4384C18.5373 21.0143 18.8395 20.4151 18.89 19.7701V14.6461C18.89 14.4283 18.9765 14.2194 19.1305 14.0654C19.2845 13.9114 19.4934 13.8249 19.7111 13.8249C19.9289 13.8249 20.1378 13.9114 20.2918 14.0654C20.4458 14.2194 20.5323 14.4283 20.5323 14.6461V19.7701C20.4811 20.8506 20.0056 21.8672 19.2092 22.5991C18.4127 23.3309 17.3596 23.719 16.2787 23.6788ZM22.7576 12.7656C22.8346 12.6893 22.8957 12.5985 22.9374 12.4984C22.9791 12.3983 23.0005 12.291 23.0005 12.1826C23.0005 12.0742 22.9791 11.9669 22.9374 11.8668C22.8957 11.7667 22.8346 11.6759 22.7576 11.5996L12.0826 0.924538C12.0062 0.847572 11.9154 0.786482 11.8154 0.744793C11.7153 0.703104 11.608 0.681641 11.4996 0.681641C11.3912 0.681641 11.2838 0.703104 11.1838 0.744793C11.0837 0.786482 10.9929 0.847572 10.9165 0.924538L0.241495 11.5996C0.0868685 11.7542 0 11.9639 0 12.1826C0 12.4013 0.0868685 12.611 0.241495 12.7656C0.396122 12.9203 0.605842 13.0071 0.824517 13.0071C1.04319 13.0071 1.25291 12.9203 1.40754 12.7656L11.4996 2.66539L21.5916 12.7656C21.6679 12.8426 21.7587 12.9037 21.8588 12.9454C21.9589 12.9871 22.0662 13.0085 22.1746 13.0085C22.283 13.0085 22.3903 12.9871 22.4904 12.9454C22.5905 12.9037 22.6813 12.8426 22.7576 12.7656Z'
        fill='#282828'
      />
    </svg>
  )
}
export const LogoIonah = () => {
  return (
    <svg
      width={127}
      height={36}
      viewBox='0 0 127 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='black'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.828 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='black'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='black'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='black'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint0_radial_12683_44538)'
      />
      <path
        d='M4.48123 0.5C3.23785 0.5 2.1775 0.934113 1.3065 1.80234C0.4355 2.67057 0 3.72754 0 4.96696C0 6.20639 0.4355 7.26336 1.3065 8.13159C2.1775 8.99981 3.23785 9.43392 4.48123 9.43392C5.72462 9.43392 6.78497 8.99981 7.65597 8.13159C8.52697 7.26336 8.96247 6.20639 8.96247 4.96696C8.96247 3.72754 8.52697 2.67057 7.65597 1.80234C6.79128 0.934113 5.73093 0.5 4.48123 0.5Z'
        fill='url(#paint1_radial_12683_44538)'
      />
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='white'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.8281 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='white'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='white'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='white'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint2_radial_12683_44538)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#004C96' />
          <stop offset='0.00278669' stopColor='#004E96' />
          <stop offset='0.0705' stopColor='#00869B' />
          <stop offset='0.1333' stopColor='#00B29F' />
          <stop offset='0.1893' stopColor='#00D2A2' />
          <stop offset='0.2363' stopColor='#00E5A3' />
          <stop offset='0.2688' stopColor='#00ECA4' />
          <stop offset='0.6341' stopColor='#00B18C' />
          <stop offset='1' stopColor='#1E2492' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.81549 3.13041) scale(36.1413 36.0262)'
        >
          <stop stopColor='#4FFFA4' />
          <stop offset='0.0389' stopColor='#3FE79F' />
          <stop offset='0.1141' stopColor='#24BF97' />
          <stop offset='0.1827' stopColor='#10A191' />
          <stop offset='0.2417' stopColor='#048F8D' />
          <stop offset='0.2844' stopColor='#00898C' />
          <stop offset='0.3647' stopColor='#00778F' />
          <stop offset='0.4957' stopColor='#005F93' />
          <stop offset='0.6179' stopColor='#005195' />
          <stop offset='0.7218' stopColor='#004C96' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#00ECA4' />
          <stop offset='0.3946' stopColor='#00B1A6' />
          <stop offset='0.4002' stopColor='#00B0A7' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8184' stopColor='#064BF2' />
          <stop offset='0.9368' stopColor='#172FCE' />
          <stop offset='1' stopColor='#1E24C0' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const MiniLogo = () => {
  return (
    <svg
      width={30}
      height={28}
      viewBox='0 0 30 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='#004C93'
      />
      <path
        d='M3.45024 0C2.48808 0 1.67626 0.329233 1.00726 0.980383C0.338259 1.63153 0 2.42169 0 3.35818C0 4.28734 0.338259 5.08482 1.00726 5.73597C1.67626 6.38712 2.48808 6.71635 3.45024 6.71635C4.40488 6.71635 5.22422 6.38712 5.89322 5.73597C6.56222 5.08482 6.90047 4.29466 6.90047 3.35818C6.90047 2.42901 6.56222 1.63153 5.89322 0.980383C5.2167 0.329233 4.40488 0 3.45024 0Z'
        fill='url(#paint0_radial_2060_15718)'
      />
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='url(#paint1_radial_2060_15718)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.93368 1.97481) scale(27.7886 27.0471)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.81293 2.10869) scale(38.422 37.3968)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const LogoIonahLight = () => {
  return (
    <svg viewBox='0 0 142 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_534_1186)'>
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='black'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#231F20'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#231F20'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#231F20'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint0_radial_534_1186)'
        />
        <path
          d='M5.02142 0C3.62111 0 2.4396 0.487409 1.46595 1.45139C0.492296 2.41538 0 3.58516 0 4.97157C0 6.34714 0.492296 7.52776 1.46595 8.49174C2.4396 9.45573 3.62111 9.94314 5.02142 9.94314C6.41079 9.94314 7.60324 9.45573 8.57689 8.49174C9.55054 7.52776 10.0428 6.35797 10.0428 4.97157C10.0428 3.59599 9.55054 2.41538 8.57689 1.45139C7.5923 0.487409 6.41079 0 5.02142 0Z'
          fill='url(#paint1_radial_534_1186)'
        />
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='#161616'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#161616'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#161616'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#161616'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint2_radial_534_1186)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.26963 2.92359) scale(40.4431 40.0416)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
        <clipPath id='clip0_534_1186'>
          <rect width={142} height={40} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const Heart = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 32 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.423 3.79859C27.697 3.06987 26.8349 2.4918 25.8861 2.0974C24.9373 1.703 23.9203 1.5 22.8933 1.5C21.8663 1.5 20.8493 1.703 19.9005 2.0974C18.9517 2.4918 18.0896 3.06987 17.3636 3.79859L15.8568 5.31023L14.3499 3.79859C12.8834 2.32732 10.8943 1.50076 8.82022 1.50076C6.74617 1.50076 4.75706 2.32732 3.29049 3.79859C1.82391 5.26986 1 7.26534 1 9.34603C1 11.4267 1.82391 13.4222 3.29049 14.8935L4.7973 16.4051L15.8568 27.5L26.9162 16.4051L28.423 14.8935C29.1494 14.1651 29.7256 13.3003 30.1188 12.3484C30.5119 11.3966 30.7143 10.3764 30.7143 9.34603C30.7143 8.31571 30.5119 7.29548 30.1188 6.34363C29.7256 5.39178 29.1494 4.52697 28.423 3.79859Z'
        stroke='{stroke}'
        strokeWidth='{2}'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Downs = () => {
  return (
    <svg
      width={8}
      height={6}
      viewBox='0 0 8 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.943 0.269C7.90079 0.187965 7.83717 0.120046 7.75907 0.0726213C7.68097 0.025197 7.59137 8.04183e-05 7.5 0H0.5C0.408544 7.81986e-05 0.318862 0.0252388 0.240712 0.0727439C0.162562 0.120249 0.0989375 0.188279 0.0567636 0.26943C0.0145897 0.350581 -0.0045187 0.441746 0.00151773 0.533002C0.00755416 0.624258 0.0385044 0.712111 0.091 0.787L3.591 5.787C3.63714 5.85261 3.69839 5.90616 3.76957 5.94313C3.84076 5.98009 3.91979 5.99939 4 5.99939C4.08021 5.99939 4.15924 5.98009 4.23043 5.94313C4.30161 5.90616 4.36286 5.85261 4.409 5.787L7.909 0.787C7.96154 0.712043 7.9925 0.6241 7.99849 0.532758C8.00449 0.441417 7.98529 0.350182 7.943 0.269Z'
        fill='#2f343733'
      />
    </svg>
  )
}
export const IconCartHome = () => {
  return (
    <img
      src='/assets/icons/header/shopping-cart.svg'
      alt='shopping-cart'
      width={26}
    />
  )
}
export const IconsDownsLocate = () => {
  return (
    <svg
      width={12}
      height={8}
      viewBox='0 0 12 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 2L6 6L2 2'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const SearchIcon = () => {
  return (
    <button className='start-[-1px] flex h-[48px] min-w-[48px] items-center justify-center rounded-e-[6px] bg-primary-second p-0'>
      <svg
        width={16}
        height={16}
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M11.742 10.3281C12.7121 9.00176 13.1459 7.3582 12.9566 5.72592C12.7674 4.09364 11.9691 2.59292 10.7213 1.52375C9.4735 0.454573 7.86815 -0.104269 6.22616 -0.0410676C4.58416 0.0221341 3.02651 0.702723 1.86459 1.86465C0.702662 3.02657 0.0220731 4.58422 -0.0411286 6.22622C-0.10433 7.86821 0.454512 9.47357 1.52368 10.7214C2.59286 11.9692 4.09358 12.7675 5.72586 12.9567C7.35814 13.1459 9.0017 12.7121 10.328 11.7421L14.293 15.7071C14.4816 15.8892 14.7342 15.99 14.9964 15.9877C15.2586 15.9855 15.5094 15.8803 15.6948 15.6949C15.8802 15.5095 15.9854 15.2587 15.9877 14.9965C15.9899 14.7343 15.8892 14.4817 15.707 14.2931L11.742 10.3281ZM2 6.50006C2 5.61004 2.26392 4.74001 2.75838 3.99999C3.25285 3.25997 3.95565 2.68319 4.77792 2.3426C5.60019 2.002 6.50499 1.91289 7.3779 2.08652C8.25082 2.26016 9.05264 2.68874 9.68198 3.31808C10.3113 3.94741 10.7399 4.74924 10.9135 5.62215C11.0872 6.49506 10.998 7.39986 10.6575 8.22213C10.3169 9.0444 9.74008 9.7472 9.00006 10.2417C8.26004 10.7361 7.39001 11.0001 6.5 11.0001C5.30693 10.9987 4.1631 10.5242 3.31948 9.68058C2.47585 8.83695 2.00132 7.69312 2 6.50006Z'
          fill='white'
        />
      </svg>
    </button>
  )
}
export const Star = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={11}
      height={10}
      viewBox='0 0 11 10'
      fill='none'
    >
      <path
        d='M5.5 0.0310059L6.96946 3.16517L10.2553 3.66776L7.87764 6.10737L8.43893 9.55215L5.5 7.92574L2.56107 9.55215L3.12236 6.10737L0.744718 3.66776L4.03054 3.16517L5.5 0.0310059Z'
        fill='#555555'
      />
    </svg>
  )
}
export const StarRated = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1481_21100)'>
        <path
          d='M15.1441 5.577L10.8271 4.949L8.90008 1.038C8.80851 0.880461 8.67719 0.749722 8.51925 0.658846C8.36132 0.56797 8.18229 0.520142 8.00008 0.520142C7.81786 0.520142 7.63884 0.56797 7.4809 0.658846C7.32297 0.749722 7.19165 0.880461 7.10008 1.038L5.17308 4.95L0.856079 5.577C0.671214 5.60351 0.497468 5.68126 0.354521 5.80144C0.211573 5.92163 0.105137 6.07944 0.0472671 6.257C-0.0106025 6.43456 -0.0175924 6.62479 0.0270889 6.80612C0.0717703 6.98745 0.166337 7.15265 0.300079 7.283L3.42308 10.328L2.68608 14.628C2.65457 14.8119 2.67514 15.0009 2.74546 15.1738C2.81578 15.3466 2.93305 15.4963 3.08401 15.606C3.23497 15.7156 3.41359 15.7808 3.59969 15.7943C3.78579 15.8077 3.97193 15.7688 4.13708 15.682L8.00008 13.651L11.8611 15.68C12.0262 15.7668 12.2124 15.8057 12.3985 15.7923C12.5846 15.7788 12.7632 15.7136 12.9142 15.604C13.0651 15.4943 13.1824 15.3446 13.2527 15.1718C13.323 14.9989 13.3436 14.8099 13.3121 14.626L12.5751 10.326L15.7001 7.283C15.8335 7.15274 15.9278 6.98778 15.9724 6.80674C16.017 6.6257 16.0102 6.43579 15.9525 6.25846C15.8949 6.08113 15.7889 5.92345 15.6464 5.80321C15.5039 5.68296 15.3306 5.60496 15.1461 5.578L15.1441 5.577Z'
          fill='#F2A41C'
        />
      </g>
      <defs>
        <clipPath id='clip0_1481_21100'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.137939)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const StarRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_590_6315)'>
        <path
          d='M15.1441 5.43918L10.8271 4.81118L8.90008 0.900179C8.80851 0.742644 8.67719 0.611904 8.51925 0.521028C8.36132 0.430153 8.18229 0.382324 8.00008 0.382324C7.81786 0.382324 7.63884 0.430153 7.4809 0.521028C7.32297 0.611904 7.19165 0.742644 7.10008 0.900179L5.17308 4.81218L0.856079 5.43918C0.671214 5.46569 0.497468 5.54344 0.354521 5.66363C0.211573 5.78381 0.105137 5.94162 0.0472671 6.11918C-0.0106025 6.29675 -0.0175924 6.48697 0.0270889 6.6683C0.0717703 6.84963 0.166337 7.01483 0.300079 7.14518L3.42308 10.1902L2.68608 14.4902C2.65457 14.6741 2.67514 14.8631 2.74546 15.036C2.81578 15.2088 2.93305 15.3585 3.08401 15.4681C3.23497 15.5778 3.41359 15.643 3.59969 15.6565C3.78579 15.6699 3.97193 15.631 4.13708 15.5442L8.00008 13.5132L11.8611 15.5422C12.0262 15.629 12.2124 15.6679 12.3985 15.6545C12.5846 15.641 12.7632 15.5758 12.9142 15.4661C13.0651 15.3565 13.1824 15.2068 13.2527 15.034C13.323 14.8611 13.3436 14.6721 13.3121 14.4882L12.5751 10.1882L15.7001 7.14518C15.8335 7.01492 15.9278 6.84996 15.9724 6.66892C16.017 6.48788 16.0102 6.29797 15.9525 6.12065C15.8949 5.94332 15.7889 5.78563 15.6464 5.66539C15.5039 5.54515 15.3306 5.46714 15.1461 5.44018L15.1441 5.43918Z'
          fill='#F2A41C'
        />
      </g>
      <defs>
        <clipPath id='clip0_590_6315'>
          <rect width={16} height={16} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconDelivery = () => {
  return (
    <img
      src='/assets/icons/header/tracking.svg'
      alt='tracking-order'
      width={26}
    />
  )
}
export const IconDowns = () => {
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.97481 4.4709L6.12513 8.32058L2.48236 4.6778'
        stroke='white'
        strokeWidth={2}
        strokeLinecap='round'
      />
    </svg>
  )
}
export const IconLocation = () => {
  return (
    <svg
      width={18}
      height={24}
      viewBox='0 0 18 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 9C17 13.9 9 22 9 22C9 22 1 13.9 1 9C1 3.9 5.1 1 9 1C12.9 1 17 3.9 17 9Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconSearch = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M11.7411 10.3281C12.7112 9.00176 13.145 7.3582 12.9557 5.72592C12.7665 4.09364 11.9682 2.59292 10.7204 1.52375C9.47259 0.454573 7.86723 -0.104269 6.22524 -0.0410676C4.58325 0.0221341 3.0256 0.702723 1.86367 1.86465C0.701746 3.02657 0.0211575 4.58422 -0.0420441 6.22622C-0.105246 7.86821 0.453597 9.47357 1.52277 10.7214C2.59194 11.9692 4.09267 12.7675 5.72495 12.9567C7.35722 13.1459 9.00078 12.7121 10.3271 11.7421L14.2921 15.7071C14.4807 15.8892 14.7333 15.99 14.9955 15.9877C15.2577 15.9855 15.5085 15.8803 15.6939 15.6949C15.8793 15.5095 15.9845 15.2587 15.9868 14.9965C15.989 14.7343 15.8882 14.4817 15.7061 14.2931L11.7411 10.3281ZM1.99908 6.50006C1.99908 5.61004 2.263 4.74001 2.75747 3.99999C3.25193 3.25997 3.95474 2.68319 4.777 2.3426C5.59927 2.002 6.50407 1.91289 7.37699 2.08652C8.2499 2.26016 9.05172 2.68874 9.68106 3.31808C10.3104 3.94741 10.739 4.74924 10.9126 5.62215C11.0862 6.49506 10.9971 7.39986 10.6565 8.22213C10.3159 9.0444 9.73917 9.7472 8.99915 10.2417C8.25912 10.7361 7.3891 11.0001 6.49908 11.0001C5.30601 10.9987 4.16219 10.5242 3.31856 9.68058C2.47493 8.83695 2.0004 7.69312 1.99908 6.50006Z'
        fill='#303538'
      />
    </svg>
  )
}
export const IconCheckBlue = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={15}
      height={13}
      viewBox='0 0 15 13'
      fill='none'
    >
      <path
        d='M13.2375 0.808838L5 9.20374L1.7625 5.91712L0 7.7133L5 12.8088L15 2.61776L13.2375 0.808838Z'
        fill='#00C1D5'
      />
    </svg>
  )
}
export const IconCheckRed = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={17}
      viewBox='0 0 17 17'
      fill='none'
    >
      <path
        d='M8.5 0.404053C4.084 0.404053 0.5 3.98805 0.5 8.40405C0.5 12.8201 4.084 16.4041 8.5 16.4041C12.916 16.4041 16.5 12.8201 16.5 8.40405C16.5 3.98805 12.916 0.404053 8.5 0.404053ZM8.5 14.8041C4.972 14.8041 2.1 11.9321 2.1 8.40405C2.1 4.87605 4.972 2.00405 8.5 2.00405C12.028 2.00405 14.9 4.87605 14.9 8.40405C14.9 11.9321 12.028 14.8041 8.5 14.8041ZM12.172 4.86805L6.9 10.1401L4.828 8.07605L3.7 9.20405L6.9 12.4041L13.3 6.00405L12.172 4.86805Z'
        fill='#EE2E24'
      />
    </svg>
  )
}
export const Notification = () => {
  return (
    <svg
      width={27}
      height={30}
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='#ffffff'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='#ffffff'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const MenuHeader = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 7H1C0.4 7 0 7.4 0 8C0 8.6 0.4 9 1 9H15C15.6 9 16 8.6 16 8C16 7.4 15.6 7 15 7Z'
        fill='#212121'
      />
      <path
        d='M15 1H1C0.4 1 0 1.4 0 2C0 2.6 0.4 3 1 3H15C15.6 3 16 2.6 16 2C16 1.4 15.6 1 15 1Z'
        fill='#212121'
      />
      <path
        d='M15 13H1C0.4 13 0 13.4 0 14C0 14.6 0.4 15 1 15H15C15.6 15 16 14.6 16 14C16 13.4 15.6 13 15 13Z'
        fill='#212121'
      />
    </svg>
  )
}
export const IconCartHomeMobi = () => {
  return (
    <svg
      width={24}
      height={23}
      viewBox='0 0 24 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        fill='#303538'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        fill='#303538'
      />
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M4.8 6H22L20 16H6L4 1H1'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
////////////////////Delete Later/////////////////////
export const TiviIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 22H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M23 2H1V18H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const AirCondIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 13H3C1.89543 13 1 13.8954 1 15V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V15C23 13.8954 22.1046 13 21 13Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 18H5'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 7V2'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M17 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const FridgeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 1H3V23H21V1Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M21 10H3'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d='M7 5V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 14V17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const WashingIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 23V1L3 1V23H21Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 19C14.7614 19 17 16.7614 17 14C17 11.2386 14.7614 9 12 9C9.23858 9 7 11.2386 7 14C7 16.7614 9.23858 19 12 19Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 5H10'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M16 5H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const HobIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const MicrowaveIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 3H1V21H23V3Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 16H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 12H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 8H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M14 8H5V16H14V8Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const SelectedIcon = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z'
        fill='#4294FE'
      />
    </svg>
  )
}

export const IconPlus = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={13}
      height={14}
      viewBox='0 0 13 14'
      fill='none'
    >
      <path
        d='M7.02285 0.674805H5.97634C5.88331 0.674805 5.8368 0.721316 5.8368 0.81434V6.29108H0.639535C0.546512 6.29108 0.5 6.33759 0.5 6.43062V7.47713C0.5 7.57015 0.546512 7.61667 0.639535 7.61667H5.8368V13.0934C5.8368 13.1864 5.88331 13.2329 5.97634 13.2329H7.02285C7.11587 13.2329 7.16238 13.1864 7.16238 13.0934V7.61667H12.3605C12.4535 7.61667 12.5 7.57015 12.5 7.47713V6.43062C12.5 6.33759 12.4535 6.29108 12.3605 6.29108H7.16238V0.81434C7.16238 0.721316 7.11587 0.674805 7.02285 0.674805Z'
        fill='black'
        fillOpacity='0.85'
      />
    </svg>
  )
}
export const CouponIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={30}
      height={31}
      viewBox='0 0 30 31'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 0.5C23.2843 0.5 30 7.21572 30 15.5C30 23.7843 23.2843 30.5 15 30.5C6.71572 30.5 0 23.7843 0 15.5C0 7.21572 6.71572 0.5 15 0.5ZM7.01543 20.6554H9.07207V10.3445H7.01543C6.70884 10.3451 6.41499 10.4673 6.19836 10.6842C5.98172 10.9012 5.85998 11.1952 5.85984 11.5018V13.7506C5.85963 13.8066 5.88141 13.8603 5.92049 13.9004C5.95957 13.9404 6.01281 13.9634 6.06873 13.9646C6.47027 13.9731 6.85246 14.1387 7.1334 14.4257C7.41434 14.7127 7.57167 15.0984 7.57167 15.5C7.57167 15.9016 7.41434 16.2873 7.1334 16.5743C6.85246 16.8613 6.47027 17.0269 6.06873 17.0354C6.01281 17.0366 5.95957 17.0596 5.92049 17.0996C5.88141 17.1397 5.85963 17.1934 5.85984 17.2494V19.4982C5.85998 19.8048 5.98172 20.0988 6.19836 20.3158C6.415 20.5327 6.70884 20.6549 7.01543 20.6554ZM9.49981 20.6554H22.9829C23.2898 20.6552 23.584 20.5332 23.801 20.3162C24.0179 20.0993 24.1399 19.805 24.1402 19.4982V17.2494C24.1401 17.1927 24.1175 17.1383 24.0774 17.0982C24.0373 17.0581 23.9829 17.0355 23.9262 17.0354C23.519 17.0354 23.1285 16.8737 22.8405 16.5857C22.5526 16.2978 22.3908 15.9072 22.3908 15.5C22.3908 15.0928 22.5526 14.7022 22.8405 14.4143C23.1285 14.1263 23.519 13.9646 23.9262 13.9646C23.9829 13.9645 24.0373 13.9419 24.0774 13.9018C24.1175 13.8617 24.1401 13.8073 24.1402 13.7506V11.5018C24.1399 11.1949 24.0179 10.9007 23.801 10.6838C23.584 10.4668 23.2898 10.3448 22.9829 10.3445H9.50004V20.6554H9.49981ZM7.199 11.0586C7.07533 11.0583 6.95434 11.0946 6.85135 11.1631C6.74836 11.2315 6.66799 11.329 6.62042 11.4432C6.57285 11.5573 6.56023 11.683 6.58413 11.8044C6.60804 11.9257 6.66741 12.0372 6.75473 12.1248C6.84204 12.2124 6.95338 12.2721 7.07465 12.2964C7.19591 12.3206 7.32165 12.3084 7.43595 12.2612C7.55025 12.2139 7.64797 12.1339 7.71674 12.0311C7.7855 11.9283 7.82223 11.8074 7.82227 11.6837C7.82237 11.5182 7.7568 11.3594 7.63995 11.2422C7.5231 11.125 7.36451 11.059 7.199 11.0586ZM7.199 11.8807C7.23799 11.8807 7.27611 11.8691 7.30853 11.8475C7.34095 11.8258 7.36622 11.795 7.38115 11.759C7.39608 11.723 7.39999 11.6834 7.39239 11.6451C7.38479 11.6069 7.36602 11.5718 7.33846 11.5442C7.3109 11.5166 7.27578 11.4978 7.23754 11.4902C7.1993 11.4826 7.15967 11.4865 7.12365 11.5014C7.08763 11.5164 7.05684 11.5416 7.03518 11.574C7.01351 11.6065 7.00195 11.6446 7.00195 11.6836C7.00194 11.7094 7.00702 11.7351 7.01692 11.759C7.02682 11.7829 7.04133 11.8046 7.05963 11.8229C7.07793 11.8413 7.09966 11.8558 7.12357 11.8657C7.14749 11.8756 7.17312 11.8807 7.199 11.8807ZM22.801 12.3084C22.9246 12.3084 23.0454 12.2717 23.1482 12.2031C23.251 12.1344 23.3311 12.0368 23.3784 11.9226C23.4257 11.8084 23.4381 11.6827 23.4139 11.5615C23.3898 11.4403 23.3303 11.3289 23.2429 11.2415C23.1555 11.1541 23.0442 11.0946 22.9229 11.0705C22.8017 11.0464 22.676 11.0587 22.5618 11.106C22.4476 11.1534 22.35 11.2335 22.2814 11.3362C22.2127 11.439 22.176 11.5598 22.176 11.6834C22.176 11.7655 22.1922 11.8468 22.2236 11.9226C22.255 11.9985 22.301 12.0674 22.359 12.1254C22.4171 12.1834 22.486 12.2295 22.5618 12.2609C22.6376 12.2923 22.7189 12.3084 22.801 12.3084ZM22.801 11.4863C22.762 11.4863 22.7239 11.4979 22.6915 11.5195C22.659 11.5412 22.6338 11.5719 22.6188 11.608C22.6039 11.644 22.6 11.6836 22.6076 11.7219C22.6152 11.7601 22.634 11.7952 22.6615 11.8228C22.6891 11.8504 22.7242 11.8691 22.7625 11.8768C22.8007 11.8844 22.8403 11.8805 22.8764 11.8655C22.9124 11.8506 22.9432 11.8254 22.9648 11.793C22.9865 11.7605 22.998 11.7224 22.998 11.6834C22.9981 11.6576 22.993 11.6319 22.9831 11.608C22.9732 11.5841 22.9587 11.5624 22.9404 11.544C22.9221 11.5257 22.9003 11.5112 22.8764 11.5013C22.8525 11.4914 22.8269 11.4863 22.801 11.4863ZM7.199 19.9414C7.32261 19.9414 7.44345 19.9048 7.54624 19.8362C7.64904 19.7675 7.72917 19.67 7.7765 19.5558C7.82383 19.4416 7.83625 19.3159 7.81217 19.1947C7.78809 19.0735 7.7286 18.9621 7.64122 18.8747C7.55384 18.7872 7.4425 18.7277 7.32128 18.7035C7.20005 18.6794 7.07439 18.6917 6.96018 18.739C6.84597 18.7863 6.74834 18.8663 6.67964 18.9691C6.61094 19.0718 6.57425 19.1927 6.57422 19.3163C6.57431 19.482 6.64016 19.6409 6.7573 19.7581C6.87443 19.8753 7.0333 19.9412 7.199 19.9414ZM7.199 19.1193C7.15995 19.119 7.12167 19.1303 7.08904 19.1517C7.0564 19.1732 7.03087 19.2038 7.01569 19.2398C7.00051 19.2758 6.99637 19.3155 7.00378 19.3538C7.01119 19.3922 7.02983 19.4275 7.05732 19.4552C7.08482 19.4829 7.11994 19.5019 7.15822 19.5096C7.1965 19.5174 7.23622 19.5136 7.27234 19.4987C7.30845 19.4838 7.33934 19.4586 7.36107 19.4261C7.38281 19.3937 7.39441 19.3555 7.39441 19.3164C7.39435 19.2645 7.3738 19.2146 7.33722 19.1777C7.30063 19.1408 7.25097 19.1198 7.199 19.1193ZM22.801 19.9414C22.9246 19.9414 23.0454 19.9048 23.1482 19.8361C23.251 19.7674 23.3311 19.6698 23.3784 19.5556C23.4257 19.4414 23.4381 19.3158 23.4139 19.1945C23.3898 19.0733 23.3303 18.9619 23.2429 18.8745C23.1555 18.7871 23.0442 18.7276 22.9229 18.7035C22.8017 18.6794 22.676 18.6918 22.5618 18.7391C22.4476 18.7864 22.35 18.8665 22.2814 18.9692C22.2127 19.072 22.176 19.1928 22.176 19.3164C22.1763 19.4821 22.2422 19.641 22.3593 19.7581C22.4765 19.8753 22.6353 19.9412 22.801 19.9414ZM22.801 19.1193C22.762 19.1193 22.7239 19.1309 22.6915 19.1525C22.659 19.1742 22.6338 19.205 22.6188 19.241C22.6039 19.277 22.6 19.3166 22.6076 19.3549C22.6152 19.3931 22.634 19.4282 22.6615 19.4558C22.6891 19.4834 22.7242 19.5022 22.7625 19.5098C22.8007 19.5174 22.8403 19.5135 22.8764 19.4986C22.9124 19.4836 22.9432 19.4584 22.9648 19.426C22.9865 19.3935 22.998 19.3554 22.998 19.3164C22.9981 19.2906 22.993 19.2649 22.9831 19.241C22.9732 19.2171 22.9587 19.1954 22.9404 19.1771C22.9221 19.1587 22.9003 19.1442 22.8764 19.1343C22.8525 19.1244 22.8269 19.1193 22.801 19.1193ZM13.8798 17.9248C13.8502 17.9549 13.83 17.9931 13.822 18.0345C13.8139 18.076 13.8182 18.1189 13.8344 18.1579C13.8506 18.1969 13.8779 18.2303 13.9129 18.2538C13.948 18.2774 13.9892 18.2901 14.0314 18.2904C14.0884 18.2899 14.1429 18.2669 14.183 18.2264L19.3342 13.0752C19.3734 13.0348 19.395 12.9806 19.3945 12.9244C19.3939 12.8682 19.3713 12.8144 19.3314 12.7748C19.2916 12.7351 19.2377 12.7128 19.1815 12.7126C19.1253 12.7124 19.0712 12.7343 19.0311 12.7736L13.8798 17.9248ZM18.2494 15.7299C17.9227 15.7297 17.606 15.8429 17.3533 16.05C17.1005 16.2572 16.9275 16.5455 16.8635 16.8659C16.7996 17.1864 16.8487 17.5191 17.0025 17.8074C17.1564 18.0956 17.4054 18.3217 17.7072 18.4469C18.009 18.5722 18.3449 18.589 18.6576 18.4943C18.9704 18.3997 19.2407 18.1996 19.4224 17.9281C19.6042 17.6565 19.6862 17.3304 19.6544 17.0052C19.6227 16.6799 19.4792 16.3758 19.2483 16.1445C19.1177 16.0126 18.9621 15.908 18.7906 15.8369C18.6191 15.7657 18.4351 15.7295 18.2494 15.7302V15.7299ZM18.9451 17.8389C19.0827 17.7014 19.1764 17.5261 19.2144 17.3352C19.2524 17.1444 19.2329 16.9465 19.1584 16.7668C19.0839 16.587 18.9578 16.4333 18.796 16.3252C18.6342 16.2171 18.444 16.1595 18.2494 16.1595C18.1202 16.1594 17.9923 16.1849 17.8729 16.2343C17.7535 16.2837 17.6451 16.3562 17.5537 16.4475C17.4624 16.5389 17.3899 16.6474 17.3405 16.7667C17.291 16.8861 17.2656 17.0141 17.2656 17.1433C17.2657 17.3378 17.3234 17.528 17.4315 17.6898C17.5396 17.8515 17.6933 17.9776 17.873 18.0521C18.0528 18.1265 18.2506 18.146 18.4414 18.1081C18.6322 18.0701 18.8075 17.9765 18.9451 17.8389ZM13.9657 14.8555C14.1632 15.0527 14.4148 15.1869 14.6885 15.2411C14.9623 15.2954 15.246 15.2673 15.5038 15.1604C15.7616 15.0535 15.9819 14.8726 16.1369 14.6405C16.292 14.4084 16.3747 14.1355 16.3747 13.8564C16.3747 13.5774 16.292 13.3045 16.1369 13.0724C15.9819 12.8403 15.7616 12.6594 15.5038 12.5525C15.246 12.4456 14.9623 12.4175 14.6885 12.4718C14.4148 12.526 14.1632 12.6602 13.9657 12.8574C13.8337 12.9881 13.7288 13.1437 13.6573 13.3152C13.5857 13.4867 13.5489 13.6706 13.5489 13.8564C13.5489 14.0422 13.5857 14.2262 13.6573 14.3977C13.7288 14.5692 13.8337 14.7248 13.9657 14.8555ZM14.2689 13.1609C14.0845 13.3455 13.981 13.5957 13.981 13.8566C13.981 14.1175 14.0845 14.3677 14.2689 14.5523C14.3601 14.6436 14.4685 14.7161 14.5877 14.7655C14.7069 14.8149 14.8347 14.8403 14.9638 14.8403C15.0929 14.8403 15.2207 14.8149 15.3399 14.7655C15.4591 14.7161 15.5674 14.6436 15.6587 14.5523C15.75 14.4611 15.8225 14.3527 15.872 14.2334C15.9215 14.1142 15.947 13.9863 15.9471 13.8572C15.9472 13.7281 15.9218 13.6002 15.8725 13.4809C15.8231 13.3615 15.7508 13.2531 15.6595 13.1617C15.5683 13.0704 15.4599 12.9979 15.3406 12.9484C15.2214 12.8989 15.0935 12.8734 14.9644 12.8733C14.8353 12.8732 14.7074 12.8986 14.5881 12.9479C14.4687 12.9973 14.3603 13.0696 14.2689 13.1609Z'
        fill='#ED1C24'
      />
    </svg>
  )
}
export const CouponArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={13}
      viewBox='0 0 7 13'
      fill='none'
    >
      <path
        d='M1.06125 1.21051C0.693124 1.60051 0.693124 2.23051 1.06125 2.62051L4.72368 6.50051L1.06125 10.3805C0.693124 10.7705 0.693124 11.4005 1.06125 11.7905C1.42939 12.1805 2.02406 12.1805 2.39219 11.7905L6.72481 7.20051C7.09294 6.81051 7.09294 6.18051 6.72481 5.79051L2.39219 1.20051C2.0335 0.82051 1.42939 0.82051 1.06125 1.21051Z'
        fill='#00C1D5'
      />
    </svg>
  )
}
export const IconFilter = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={18}
      viewBox='0 0 20 21'
      fill='none'
    >
      <g clipPath='url(#clip0_1387_33389)'>
        <path
          d='M18.9248 0.114259H1.09382C0.779325 0.113664 0.491008 0.289351 0.347247 0.569141C0.201502 0.852698 0.227082 1.19416 0.413278 1.45313L6.9458 10.6555C6.94799 10.6586 6.95036 10.6616 6.95255 10.6648C7.1899 10.9852 7.3182 11.3733 7.31899 11.7722V19.2748C7.3176 19.4971 7.40485 19.7104 7.5615 19.8681C7.71815 20.0257 7.93112 20.1142 8.1532 20.1142C8.26623 20.1142 8.37787 20.0916 8.48217 20.0483L12.1529 18.6486C12.4819 18.5483 12.7002 18.2379 12.7002 17.8642V11.7722C12.7008 11.3735 12.8293 10.9852 13.0665 10.6648C13.0687 10.6616 13.071 10.6586 13.0732 10.6555L19.6055 1.45273C19.7917 1.19396 19.8173 0.852698 19.6716 0.569141C19.5278 0.289351 19.2395 0.113664 18.9248 0.114259ZM12.2479 10.0634C11.8831 10.5585 11.6858 11.1571 11.6846 11.7722V17.7408L8.33424 19.0182V11.7722C8.33305 11.1571 8.13575 10.5585 7.7707 10.0634L1.42873 1.12951H18.5901L12.2479 10.0634Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_1387_33389'>
          <rect
            width={20}
            height={20}
            fill='white'
            transform='translate(0 0.114258)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LogoIconF = () => {
  return (
    <svg
      width='120'
      height='120'
      viewBox='0 0 23 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.0037 13.2478C19.7395 13.361 19.6262 13.3988 19.5507 13.0591C19.2488 12.0023 18.4939 11.2097 17.5881 10.6058C16.2294 9.73771 14.7196 9.39802 13.0967 9.28479C13.5496 9.69996 14.0403 10.1151 14.4554 10.6813C13.3609 10.4926 12.3418 10.5303 11.3228 10.719C10.3414 10.9077 9.36012 11.1719 8.34106 11.6249C9.4356 11.8891 10.4169 12.191 11.3605 12.5684C12.908 13.2101 14.3422 14.0404 15.399 15.3237C16.2294 16.3427 16.2671 16.1163 15.1726 16.8334C11.1341 19.5509 5.6613 17.0976 4.94418 12.2665C4.34029 8.07701 7.77491 4.37819 12.0021 4.71788C12.9457 4.79337 13.8893 5.01983 14.7196 5.54823C15.55 6.07663 16.6445 5.62371 17.2107 5.20853C17.3994 5.05756 17.2484 4.98208 17.1352 4.9066C16.2294 4.11399 15.1726 3.5101 14.0403 3.17041C9.05819 1.66069 4.03836 4.75562 3.09479 9.92641C2.2267 14.682 5.69906 19.3244 10.5302 19.8151C13.2477 20.0793 15.55 19.249 17.5126 17.3618C18.9091 16.003 20.3434 14.6443 21.8908 13.4365C22.0795 13.2856 22.306 13.1346 22.5325 13.0213C22.6079 12.9836 22.6834 12.9459 22.7967 12.9081C22.7967 12.9081 22.6457 12.8326 22.5702 12.8326C21.6644 12.7194 20.834 12.8704 20.0037 13.2478Z'
        fill='white'
      />
      <path
        d='M22.5326 13.0968C22.3061 13.2478 22.1174 13.361 21.891 13.512C20.3435 14.7198 18.947 16.0785 17.5128 17.4373C15.5501 19.3244 13.2478 20.1548 10.5303 19.8906C5.69921 19.3999 2.22684 14.7575 3.09493 10.0019C4.03851 4.86885 9.05834 1.77393 14.0404 3.2459C15.2105 3.58559 16.2295 4.18948 17.1354 4.98209C17.2108 5.05757 17.3995 5.13305 17.2108 5.28403C16.6447 5.6992 15.5501 6.15211 14.7198 5.62371C13.8894 5.09531 12.9836 4.86886 12.0023 4.79337C7.81281 4.45368 4.34044 8.19024 4.94433 12.342C5.66145 17.1731 11.1342 19.6264 15.1727 16.9089C16.2673 16.154 16.2295 16.3805 15.3992 15.3992C14.3046 14.0782 12.8704 13.2856 11.3606 12.6439C10.4171 12.2287 9.43575 11.9645 8.3412 11.7003C9.36027 11.2474 10.3416 10.9455 11.3229 10.7945C12.342 10.6058 13.361 10.5681 14.4556 10.7568C14.0404 10.1529 13.5875 9.77544 13.0968 9.36027C14.682 9.4735 16.2295 9.81319 17.5883 10.6813C18.4941 11.2852 19.2112 12.04 19.5509 13.1346C19.6641 13.4743 19.7774 13.4365 20.0038 13.3233C20.7964 12.9081 21.6645 12.7949 22.5703 12.9459C22.6458 12.9459 22.7968 13.0213 22.7968 13.0213C22.7968 12.9081 22.8345 12.8326 22.8345 12.7194C22.8723 12.493 22.8723 12.2287 22.8723 12.0023C22.8723 11.9645 22.8723 11.9268 22.8723 11.8891C22.8723 11.7003 22.8723 11.5116 22.8723 11.3229C22.8723 11.2474 22.8723 11.1719 22.8723 11.0965C22.8723 10.9077 22.8723 10.719 22.8345 10.5681C22.8345 10.5303 22.8345 10.4548 22.8345 10.4171C22.7968 10.1906 22.7968 9.92642 22.7591 9.69997C22.7591 9.66222 22.7591 9.66222 22.7591 9.62448C22.7213 9.43576 22.6836 9.28479 22.6458 9.09608V9.05833C22.6081 8.86962 22.5703 8.71865 22.5326 8.52993C22.5326 8.49219 22.5326 8.49218 22.5326 8.45444C22.4949 8.30347 22.4571 8.11476 22.3816 7.96378C22.3816 7.92604 22.3439 7.88829 22.3439 7.85055C22.3061 7.69958 22.2306 7.54861 22.1929 7.43538C22.1552 7.39764 22.1552 7.32215 22.1174 7.2844C22.0797 7.17117 22.0042 7.05794 21.9665 6.90697C21.9287 6.83149 21.891 6.79374 21.891 6.71826C21.8532 6.60503 21.7777 6.52955 21.74 6.41632C21.7022 6.34083 21.6645 6.26534 21.6268 6.18986C21.589 6.11437 21.5513 6.00115 21.4758 5.92566C21.4381 5.85018 21.4003 5.77469 21.3248 5.66146C21.2871 5.58597 21.2493 5.51048 21.1738 5.435C21.1361 5.35951 21.0606 5.24629 21.0229 5.1708C20.9851 5.09532 20.9474 5.01983 20.8719 4.98209C20.7964 4.9066 20.7587 4.79337 20.6832 4.71788C20.6454 4.64239 20.6077 4.60465 20.5322 4.52917C20.4567 4.45368 20.3813 4.34045 20.3435 4.26496C20.3058 4.18947 20.2303 4.15173 20.1925 4.07624C20.117 4.00076 20.0416 3.92528 19.9661 3.8498C19.9283 3.77431 19.8528 3.73657 19.8151 3.66108C19.7396 3.58559 19.6641 3.51011 19.5886 3.43462C19.5132 3.35913 19.4754 3.32139 19.3999 3.2459C19.3244 3.17042 19.2489 3.09493 19.1735 3.01944C19.098 2.94396 19.0602 2.90622 18.9847 2.86847C18.9093 2.79299 18.8338 2.75524 18.7583 2.67976C18.6828 2.64202 18.6451 2.56653 18.5696 2.52879C18.4941 2.4533 18.4186 2.41556 18.3431 2.34007C18.2676 2.30233 18.1921 2.22684 18.1544 2.18909C18.0789 2.11361 18.0034 2.07586 17.8902 2.00038C17.8147 1.96263 17.777 1.9249 17.7015 1.88715C17.626 1.81167 17.5128 1.77392 17.4373 1.69844C17.3995 1.66069 17.3241 1.62296 17.2863 1.58521C17.1731 1.50973 17.0599 1.47198 16.9466 1.3965C16.9089 1.35875 16.8711 1.35875 16.8334 1.32101C16.7202 1.24552 16.5692 1.17003 16.456 1.13229C16.4182 1.13229 16.4182 1.09455 16.3805 1.09455C14.9085 0.377428 13.2101 0 11.4739 0C10.6813 0 9.92643 0.0754884 9.20931 0.226461C9.17157 0.226461 9.13382 0.226461 9.13382 0.226461C8.98285 0.264204 8.83186 0.301942 8.71863 0.339685C8.64315 0.339685 8.60541 0.37743 8.52992 0.37743C8.41669 0.415173 8.30348 0.452921 8.19025 0.452921C8.11476 0.490664 8.03927 0.490657 7.92604 0.5284C7.85055 0.566143 7.73732 0.603893 7.66183 0.641636C7.58635 0.679379 7.47311 0.717118 7.39763 0.754861C7.32214 0.792604 7.20893 0.830342 7.13345 0.868085C7.05796 0.905828 6.94473 0.943578 6.86924 0.981321C6.79375 1.01906 6.68052 1.0568 6.60503 1.09455C6.52955 1.13229 6.45407 1.17004 6.37858 1.20778C6.3031 1.24553 6.18986 1.28327 6.11438 1.35875C6.03889 1.39649 5.96339 1.43423 5.88791 1.47198C5.81242 1.50972 5.69921 1.5852 5.62372 1.62295C5.54824 1.66069 5.47274 1.69844 5.39725 1.73618C5.32176 1.77393 5.20853 1.84941 5.13305 1.88715C5.05756 1.9249 4.98208 2.00038 4.9066 2.03812C4.83111 2.07587 4.75563 2.15135 4.68015 2.18909C4.60466 2.22684 4.52916 2.30232 4.45367 2.37781C4.37819 2.41555 4.3027 2.49105 4.26496 2.52879C4.18947 2.60427 4.11398 2.67975 4.00075 2.75524C3.96301 2.79298 3.88754 2.83073 3.8498 2.86847C3.73657 2.94396 3.66108 3.05718 3.54786 3.13267C3.51011 3.17041 3.47236 3.20816 3.47236 3.20816C3.35914 3.32139 3.2459 3.43461 3.13267 3.54784L3.09493 3.58559C1.35875 5.435 0.264192 7.81281 0.0377338 10.4171C0.0377338 10.4548 0.0377338 10.4926 0.0377338 10.5303C0.0377338 10.6813 0 10.8323 0 10.9455C0 11.021 0 11.0965 0 11.1719C0 11.2852 0 11.3984 0 11.5116C0 11.6249 0 11.7381 0 11.8513C0 11.9268 0 12.0023 0 12.0778C0 12.2287 0.0377338 12.3797 0.0377338 12.4929C0.0377338 12.5307 0.0377338 12.5684 0.0377338 12.6062C0.641623 18.3431 5.51049 22.8345 11.3984 22.8345C11.5871 22.8345 11.7758 22.8345 11.9268 22.8345C12.0023 22.8345 12.0778 22.8345 12.1533 22.8345C12.191 22.8345 12.2287 22.8345 12.2665 22.8345C12.4552 22.8345 12.6439 22.7968 12.7949 22.7591C13.8517 22.6081 14.833 22.3439 15.7389 22.0042C17.8147 21.1361 19.5509 19.7019 20.7964 17.8902C20.8342 17.8525 20.8342 17.8147 20.8719 17.777C20.8719 17.7392 20.9097 17.7392 20.9097 17.7015C21.4758 16.7957 21.9665 15.7389 22.3439 14.6066C22.4949 14.0782 22.6081 13.5498 22.6836 12.9836C22.6836 12.9836 22.6081 13.0591 22.5326 13.0968Z'
        fill='#009AB1'
      />
    </svg>
  )
}
export const IconMenu = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.6673 28V25.3333C26.6673 23.9188 26.1054 22.5623 25.1052 21.5621C24.105 20.5619 22.7485 20 21.334 20H10.6673C9.25283 20 7.89628 20.5619 6.89608 21.5621C5.89589 22.5623 5.33398 23.9188 5.33398 25.3333V28'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9993 14.6667C18.9449 14.6667 21.3327 12.2789 21.3327 9.33333C21.3327 6.38781 18.9449 4 15.9993 4C13.0538 4 10.666 6.38781 10.666 9.33333C10.666 12.2789 13.0538 14.6667 15.9993 14.6667Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconListOrder = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={25}
      viewBox='0 0 26 25'
      fill={active ? '#00C1D5' : 'black'}
    >
      <path
        d='M22.4937 18.875C22.4937 20.8836 20.7899 22.525 18.6875 22.525H7.75C5.64756 22.525 3.94375 20.8836 3.94375 18.875V5.375C3.94375 3.36641 5.64756 1.725 7.75 1.725H18.6875C20.7899 1.725 22.4937 3.36641 22.4937 5.375V18.875ZM7.75 3.025C6.40624 3.025 5.30625 4.07524 5.30625 5.375V18.875C5.30625 20.1748 6.40624 21.225 7.75 21.225H18.6875C20.0313 21.225 21.1313 20.1748 21.1313 18.875V5.375C21.1313 4.07524 20.0313 3.025 18.6875 3.025H7.75Z'
        fill={active ? '#00C1D5' : 'black'}
        stroke='white'
        strokeWidth='0.2'
      />
      <path
        d='M11.6562 12.875H17.9062C18.3381 12.875 18.6875 12.5392 18.6875 12.125C18.6875 11.7108 18.3381 11.375 17.9062 11.375H11.6562C11.2244 11.375 10.875 11.7108 10.875 12.125C10.875 12.5392 11.2244 12.875 11.6562 12.875Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M11.6562 9.125H17.9062C18.3381 9.125 18.6875 8.78918 18.6875 8.375C18.6875 7.96082 18.3381 7.625 17.9062 7.625H11.6562C11.2244 7.625 10.875 7.96082 10.875 8.375C10.875 8.78918 11.2244 9.125 11.6562 9.125Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M11.6562 16.625H17.9062C18.3381 16.625 18.6875 16.2892 18.6875 15.875C18.6875 15.4608 18.3381 15.125 17.9062 15.125H11.6562C11.2244 15.125 10.875 15.4608 10.875 15.875C10.875 16.2892 11.2244 16.625 11.6562 16.625Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M8.54654 9.125C8.97836 9.125 9.32779 8.78918 9.32779 8.375C9.32779 7.96082 8.97836 7.625 8.54654 7.625H8.53891C8.10785 7.625 7.76147 7.96082 7.76147 8.375C7.76147 8.78918 8.11548 9.125 8.54654 9.125Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M8.54654 12.875C8.97836 12.875 9.32779 12.5392 9.32779 12.125C9.32779 11.7108 8.97836 11.375 8.54654 11.375H8.53891C8.10785 11.375 7.76147 11.7108 7.76147 12.125C7.76147 12.5392 8.11548 12.875 8.54654 12.875Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M8.54654 16.625C8.97836 16.625 9.32779 16.2892 9.32779 15.875C9.32779 15.4608 8.97836 15.125 8.54654 15.125H8.53891C8.10785 15.125 7.76147 15.4608 7.76147 15.875C7.76147 16.2892 8.11548 16.625 8.54654 16.625Z'
        fill={active ? '#00C1D5' : 'black'}
      />
    </svg>
  )
}
export const IconFaq = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={21}
      viewBox='0 0 17 21'
      fill='none'
    >
      <path
        d='M16.5673 5.64962C16.5576 5.10965 16.5484 4.59955 16.5484 4.10606C16.5484 3.71945 16.2526 3.40601 15.8876 3.40601C13.0616 3.40601 10.9099 2.5456 9.11645 0.698219C8.85988 0.43388 8.4516 0.433974 8.19512 0.698219C6.40182 2.5456 4.25053 3.40601 1.42471 3.40601C1.05978 3.40601 0.76392 3.71945 0.76392 4.10606C0.76392 4.59964 0.754757 5.10993 0.744977 5.64999C0.654404 10.675 0.530352 17.5571 8.43935 20.4614C8.50949 20.4871 8.58261 20.5 8.65574 20.5C8.72887 20.5 8.80208 20.4871 8.87213 20.4614C16.7817 17.557 16.6579 10.6748 16.5673 5.64962ZM8.65583 19.0571C1.87282 16.4466 1.97538 10.7282 2.06639 5.67669C2.07185 5.37352 2.07714 5.07969 2.08084 4.79164C4.72754 4.67329 6.84402 3.82361 8.65583 2.15152C10.4678 3.82361 12.5846 4.67338 15.2315 4.79164C15.2352 5.07959 15.2405 5.37324 15.246 5.67622C15.3369 10.7279 15.4394 16.4465 8.65583 19.0571Z'
        fill='#010103'
      />
      <path
        d='M10.9308 8.06828L7.74141 11.4469L6.38044 10.0051C6.12238 9.73178 5.70396 9.73178 5.44599 10.0051C5.18793 10.2786 5.18793 10.7217 5.44599 10.9951L7.27419 12.9319C7.40317 13.0686 7.57234 13.1369 7.74141 13.1369C7.91049 13.1369 8.07965 13.0686 8.20864 12.9319L11.8651 9.05834C12.1233 8.78494 12.1233 8.34167 11.8652 8.06837C11.6072 7.79498 11.1888 7.79489 10.9308 8.06828Z'
        fill='#010103'
      />
    </svg>
  )
}
export const IconRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={18}
      viewBox='0 0 17 18'
      fill='none'
    >
      <g clipPath='url(#clip0_3639_8392)'>
        <path
          d='M15.1683 0.65H1.83172C0.766485 0.65 -0.1 1.51645 -0.1 2.58168V13.7844C-0.1 14.8497 0.766482 15.7161 1.83172 15.7161H6.11842L8.07707 17.6748C8.18922 17.787 8.34132 17.85 8.49997 17.85C8.65857 17.85 8.81068 17.787 8.92286 17.6748L10.8815 15.7161H15.1683C16.2335 15.7161 17.1 14.8497 17.1 13.7844V2.58168C17.1 1.51645 16.2335 0.65 15.1683 0.65ZM15.9039 13.7844C15.9039 14.1899 15.5738 14.52 15.1683 14.52H10.6338C10.4752 14.52 10.3231 14.583 10.211 14.6952C10.211 14.6952 10.211 14.6952 10.2109 14.6953L8.49997 16.4062L6.78903 14.6952C6.67688 14.5831 6.52478 14.52 6.36613 14.52H1.83172C1.42619 14.52 1.09609 14.1899 1.09609 13.7844V2.58168C1.09609 2.17616 1.42618 1.84609 1.83172 1.84609H15.1683C15.5738 1.84609 15.9039 2.17616 15.9039 2.58168V13.7844Z'
          fill='black'
          stroke='black'
          strokeWidth='0.2'
        />
        <path
          d='M3.77175 6.80224L3.77175 6.80224C3.83623 6.60381 4.00774 6.45923 4.21417 6.42924L6.83587 6.04819L8.00849 3.67247C8.10082 3.48541 8.29132 3.36699 8.49991 3.36699C8.70853 3.36699 8.89903 3.48541 8.99136 3.67244L10.1641 6.0482L12.7856 6.42924C12.9921 6.45923 13.1636 6.60381 13.228 6.80227C13.228 6.80227 13.228 6.80228 13.228 6.80228L3.77175 6.80224ZM3.77175 6.80224C3.7073 7.00064 3.76108 7.21843 3.91044 7.36402L3.91044 7.36403L5.80764 9.21325M3.77175 6.80224L5.80764 9.21325M5.80764 9.21325L5.35985 11.8244C5.32459 12.03 5.40911 12.2377 5.57786 12.3604L5.57788 12.3604C5.74666 12.483 5.97041 12.4992 6.15503 12.4021L6.13177 12.3579L6.15503 12.4021L8.49991 11.1693L10.845 12.4021L10.8683 12.3579L10.845 12.4021C10.9252 12.4442 11.0128 12.4651 11.1 12.4651H11.102H11.1022C11.4042 12.4643 11.6488 12.2192 11.6488 11.917C11.6488 11.8755 11.6441 11.835 11.6354 11.796L11.1922 9.21325L5.80764 9.21325ZM6.77906 8.62947C6.90823 8.75535 6.96715 8.93675 6.93668 9.11453L6.93668 9.11453L6.62789 10.9152L8.24489 10.0651L8.24489 10.0651C8.40455 9.98113 8.59527 9.98113 8.75494 10.0651L10.3721 10.9151L10.0631 9.11457C10.0326 8.93679 10.0915 8.75534 10.2207 8.62944L11.5291 7.35423L9.72134 7.09146C9.54282 7.06552 9.38856 6.95342 9.30873 6.79171L8.49995 5.15326L7.69126 6.79167C7.61143 6.95342 7.45714 7.06552 7.27866 7.09146L5.47076 7.35423L6.77906 8.62947ZM6.77906 8.62947L6.77906 8.62947L6.74416 8.66528L6.77906 8.62947Z'
          fill='black'
          stroke='black'
          strokeWidth='0.1'
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8392'>
          <rect
            width={17}
            height={17}
            fill='white'
            transform='translate(0 0.75)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconSetting = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill='none'
    >
      <mask
        id='mask0_3639_8396'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={19}
        height={19}
      >
        <path d='M0 5.72205e-06H19V19H0V5.72205e-06Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3639_8396)'>
        <path
          d='M11.2887 2.57098C11.9448 2.74031 12.5646 3.00026 13.1337 3.33684C13.1337 3.33684 13.4079 3.06257 13.7159 2.7546C13.9395 2.53075 14.2429 2.40521 14.5593 2.40521C14.8752 2.40521 15.1787 2.53075 15.4023 2.7546C15.6736 3.0259 15.9741 3.32638 16.2454 3.59768C16.4692 3.82127 16.5948 4.12475 16.5948 4.44074C16.5948 4.75706 16.4692 5.0605 16.2454 5.28408C15.9374 5.59205 15.6632 5.86629 15.6632 5.86629C15.9997 6.4354 16.2597 7.05516 16.429 7.71133H17.2509C17.9094 7.71133 18.4434 8.24526 18.4434 8.90377V10.0962C18.4434 10.7547 17.9094 11.2887 17.2509 11.2887H16.429C16.2597 11.9448 15.9997 12.5646 15.6632 13.1337C15.6632 13.1337 15.9374 13.408 16.2454 13.7159C16.4692 13.9395 16.5948 14.243 16.5948 14.5593C16.5948 14.8753 16.4692 15.1787 16.2454 15.4023C15.9741 15.6736 15.6736 15.9741 15.4023 16.2454C15.1787 16.4693 14.8752 16.5948 14.5593 16.5948C14.2429 16.5948 13.9395 16.4693 13.7159 16.2454C13.4079 15.9374 13.1337 15.6632 13.1337 15.6632C12.5646 15.9997 11.9448 16.2597 11.2887 16.429V17.2509C11.2887 17.9094 10.7547 18.4434 10.0962 18.4434H8.90376C8.24522 18.4434 7.71133 17.9094 7.71133 17.2509V16.429C7.0552 16.2597 6.4354 15.9997 5.86629 15.6632C5.86629 15.6632 5.59205 15.9374 5.28408 16.2454C5.06049 16.4693 4.75701 16.5948 4.44073 16.5948C4.12474 16.5948 3.82123 16.4693 3.59768 16.2454C3.32641 15.9741 3.0259 15.6736 2.75459 15.4023C2.53075 15.1787 2.40521 14.8753 2.40521 14.5593C2.40521 14.243 2.53075 13.9395 2.75459 13.7159C3.06256 13.408 3.33684 13.1337 3.33684 13.1337C3.00026 12.5646 2.74034 11.9448 2.57097 11.2887H1.74911C1.09057 11.2887 0.556641 10.7547 0.556641 10.0962V8.90377C0.556641 8.24526 1.09057 7.71133 1.74911 7.71133H2.57097C2.74034 7.05516 3.00026 6.4354 3.33684 5.86629C3.33684 5.86629 3.06256 5.59205 2.75459 5.28408C2.53075 5.0605 2.40521 4.75706 2.40521 4.44074C2.40521 4.12475 2.53075 3.82127 2.75459 3.59768C3.0259 3.32638 3.32641 3.0259 3.59768 2.7546C3.82123 2.53075 4.12474 2.40521 4.44073 2.40521C4.75701 2.40521 5.06049 2.53075 5.28408 2.7546C5.59205 3.06257 5.86629 3.33684 5.86629 3.33684C6.4354 3.00026 7.0552 2.74031 7.71133 2.57098V1.74908C7.71133 1.09054 8.24522 0.556646 8.90376 0.556646H10.0962C10.7547 0.556646 11.2887 1.09054 11.2887 1.74908V2.57098Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.49995 5.92246C11.4744 5.92246 13.0773 7.5254 13.0773 9.49981C13.0773 11.4742 11.4744 13.0771 9.49995 13.0771C7.52555 13.0771 5.92261 11.4742 5.92261 9.49981C5.92261 7.5254 7.52555 5.92246 9.49995 5.92246Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export const IconUser = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill={active ? '#00C1D5' : 'none'}
    >
      <g clipPath='url(#clip0_3639_8376)'>
        <path
          d='M16.2175 2.78248C14.4232 0.988182 12.0375 0 9.5 0C6.9625 0 4.57677 0.988182 2.78248 2.78248C0.988182 4.57677 0 6.9625 0 9.5C0 12.0375 0.988182 14.4232 2.78248 16.2175C4.57677 18.0118 6.9625 19 9.5 19C12.0375 19 14.4232 18.0118 16.2175 16.2175C18.0118 14.4232 19 12.0375 19 9.5C19 6.9625 18.0118 4.57677 16.2175 2.78248ZM4.12305 15.9309C4.43674 13.2318 6.75739 11.1479 9.5 11.1479C10.9458 11.1479 12.3054 11.7112 13.3281 12.7337C14.192 13.5978 14.7369 14.726 14.8771 15.9308C13.4203 17.1509 11.5445 17.8867 9.5 17.8867C7.45551 17.8867 5.57989 17.1511 4.12305 15.9309ZM9.5 10.0013C7.90908 10.0013 6.6146 8.70679 6.6146 7.11587C6.6146 5.5248 7.90908 4.23047 9.5 4.23047C11.0909 4.23047 12.3854 5.5248 12.3854 7.11587C12.3854 8.70679 11.0909 10.0013 9.5 10.0013ZM15.8353 14.9897C15.5516 13.846 14.96 12.7914 14.1152 11.9466C13.431 11.2624 12.6215 10.7491 11.7387 10.4274C12.8 9.70773 13.4987 8.49181 13.4987 7.11587C13.4987 4.91105 11.7048 3.11719 9.5 3.11719C7.29518 3.11719 5.50132 4.91105 5.50132 7.11587C5.50132 8.49254 6.2006 9.70889 7.26271 10.4285C6.45051 10.7245 5.6989 11.1821 5.05224 11.7845C4.11581 12.6566 3.46552 13.7686 3.16401 14.9889C1.88707 13.5168 1.11328 11.5971 1.11328 9.5C1.11328 4.87553 4.87553 1.11328 9.5 1.11328C14.1245 1.11328 17.8867 4.87553 17.8867 9.5C17.8867 11.5975 17.1126 13.5177 15.8353 14.9897Z'
          fill={active ? '#00C1D5' : 'black'}
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8376'>
          <rect width={19} height={19} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const Location = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={21}
      viewBox='0 0 16 21'
      fill={active ? '#00C1D5' : 'black'}
    >
      <path
        d='M8.01869 1.21729C4.1485 1.21729 1 4.36579 1 8.23597C1 9.51007 1.5714 10.8804 1.59535 10.9382C1.7799 11.3762 2.14405 12.0566 2.40663 12.4554L7.21897 19.747C7.41591 20.0459 7.70739 20.2173 8.01869 20.2173C8.32999 20.2173 8.62147 20.0459 8.8184 19.7474L13.6312 12.4554C13.8942 12.0566 14.2579 11.3762 14.4424 10.9382C14.4664 10.8808 15.0374 9.51048 15.0374 8.23597C15.0374 4.36579 11.8889 1.21729 8.01869 1.21729ZM13.6811 10.6178C13.5164 11.0104 13.1774 11.6433 12.9417 12.0009L8.12892 19.2929C8.03396 19.437 8.00382 19.437 7.90886 19.2929L3.09611 12.0009C2.86036 11.6433 2.5214 11.01 2.35667 10.6174C2.34965 10.6004 1.82573 9.33914 1.82573 8.23597C1.82573 4.82117 4.60389 2.04301 8.01869 2.04301C11.4335 2.04301 14.2116 4.82117 14.2116 8.23597C14.2116 9.3408 13.6865 10.6054 13.6811 10.6178Z'
        fill={active ? '#00C1D5' : 'black'}
        stroke={active ? '#00C1D5' : 'black'}
        strokeWidth='0.5'
      />
      <path
        d='M8.01851 4.52028C5.96947 4.52028 4.30273 6.18742 4.30273 8.23605C4.30273 10.2847 5.96947 11.9518 8.01851 11.9518C10.0676 11.9518 11.7343 10.2847 11.7343 8.23605C11.7343 6.18742 10.0676 4.52028 8.01851 4.52028ZM8.01851 11.1261C6.42527 11.1261 5.12846 9.82971 5.12846 8.23605C5.12846 6.6424 6.42527 5.34601 8.01851 5.34601C9.61175 5.34601 10.9086 6.6424 10.9086 8.23605C10.9086 9.82971 9.61175 11.1261 8.01851 11.1261Z'
        fill={active ? '#00C1D5' : 'black'}
        stroke={active ? '#00C1D5' : 'black'}
        strokeWidth='0.5'
      />
    </svg>
  )
}
export const Coupon = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={22}
      viewBox='0 0 20 22'
      fill={active ? '#00C1D5' : 'black'}
    >
      <path
        d='M5.78597 11.3154C7.79264 11.3658 7.79597 14.4542 5.78997 14.5102C3.78331 14.4591 3.78064 11.3721 5.78597 11.3154ZM6.30931 12.9149C6.30864 12.1981 5.27064 12.1953 5.26664 12.9121C5.26931 13.6268 6.30397 13.6296 6.30931 12.9149Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M9.78652 10.3091C7.78052 10.2559 7.78052 7.16746 9.78652 7.11426C11.7932 7.16816 11.7918 10.2545 9.78652 10.3091ZM9.78652 8.16496C9.10452 8.16776 9.10452 9.25696 9.78652 9.25976C10.4685 9.25626 10.4678 8.16916 9.78652 8.16496Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M4.53978 7.40918C4.73511 7.20338 5.05312 7.20268 5.24912 7.40778L11.0424 13.4621C11.2418 13.663 11.2478 13.9955 11.0564 14.2041C10.8611 14.4183 10.5338 14.419 10.3371 14.2062L4.54312 8.15258C4.34645 7.94818 4.34511 7.61568 4.53978 7.40918Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M14.0986 7.68848C14.3746 7.68848 14.5986 7.92368 14.5986 8.21348V9.55958C14.5986 9.84938 14.3746 10.0846 14.0986 10.0846C13.8226 10.0846 13.5986 9.84938 13.5986 9.55958V8.21348C13.5986 7.92368 13.8226 7.68848 14.0986 7.68848Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M14.0986 11.541C14.3746 11.541 14.5986 11.7762 14.5986 12.066V13.4114C14.5986 13.7012 14.3746 13.9364 14.0986 13.9364C13.8226 13.9364 13.5986 13.7012 13.5986 13.4114V12.066C13.5986 11.7762 13.8226 11.541 14.0986 11.541Z'
        fill={active ? '#00C1D5' : 'black'}
      />
      <path
        d='M1.08057 9.07775C0.515903 8.75995 0.16457 8.14045 0.166569 7.46775V5.66735C0.167902 4.65585 0.947903 3.83685 1.91124 3.83545H18.0886C19.0519 3.83685 19.8319 4.65585 19.8332 5.66735V7.46635C19.8352 8.13905 19.4839 8.75855 18.9192 9.07635C18.0066 9.58945 17.6626 10.7822 18.1512 11.7405C18.3259 12.0828 18.5932 12.3635 18.9192 12.5469C19.4846 12.8654 19.8359 13.4849 19.8332 14.1583V15.9573C19.8319 16.9689 19.0519 17.7878 18.0886 17.7892H1.91124C0.947903 17.7878 0.167902 16.9689 0.166569 15.9573V14.1583C0.16457 13.4856 0.515903 12.8661 1.08057 12.5483C2.3899 11.8602 2.3799 9.76585 1.08057 9.07775ZM2.72724 12.2361C2.4599 12.7604 2.05057 13.1902 1.55124 13.4709C1.3119 13.6067 1.1639 13.8699 1.16657 14.1555V15.9545C1.16724 16.3864 1.4999 16.7357 1.91124 16.7364H13.5999C13.6272 16.2814 13.4279 15.4107 14.0999 15.3932C14.7726 15.41 14.5726 16.2849 14.5999 16.7392H18.0886C18.4999 16.7385 18.8326 16.3892 18.8332 15.9573V14.1583C18.8359 13.8727 18.6879 13.6095 18.4486 13.4737C17.0492 12.6869 16.5232 10.8578 17.2726 9.38855C17.5399 8.86425 17.9492 8.43445 18.4486 8.15375C18.6879 8.01795 18.8359 7.75475 18.8332 7.46915V5.66735C18.8326 5.23545 18.4999 4.88615 18.0886 4.88545H14.5999C14.5726 5.34115 14.7732 6.21405 14.0999 6.23155C13.4272 6.21475 13.6272 5.33975 13.5999 4.88545H1.91124C1.4999 4.88615 1.16724 5.23545 1.16657 5.66735V7.46635C1.1639 7.75195 1.3119 8.01515 1.55124 8.15095C2.95057 8.93775 3.47724 10.7668 2.72724 12.2361Z'
        fill={active ? '#00C1D5' : 'black'}
      />
    </svg>
  )
}
export const IconNotification = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={20}
      viewBox='0 0 19 20'
      fill={active ? '#00C1D5' : 'black'}
    >
      <path
        d='M16.6667 13.7044L15.6514 12.2438C15.5128 12.0452 15.4382 11.809 15.4376 11.5669V7.375C15.4376 5.80028 14.812 4.29005 13.6985 3.17655C12.585 2.06306 11.0748 1.4375 9.5001 1.4375C7.92538 1.4375 6.41515 2.06306 5.30165 3.17655C4.18816 4.29005 3.5626 5.80028 3.5626 7.375V11.5669C3.56203 11.809 3.48744 12.0452 3.34885 12.2438L2.33354 13.7044C2.1798 13.8747 2.07871 14.0859 2.04248 14.3125C2.00626 14.5391 2.03645 14.7713 2.1294 14.9811C2.22236 15.1909 2.3741 15.3692 2.56628 15.4946C2.75845 15.62 2.98284 15.687 3.21229 15.6875H6.59073C6.727 16.3586 7.0911 16.962 7.62132 17.3953C8.15155 17.8287 8.8153 18.0655 9.5001 18.0655C10.1849 18.0655 10.8487 17.8287 11.3789 17.3953C11.9091 16.962 12.2732 16.3586 12.4095 15.6875H15.7879C16.0174 15.687 16.2417 15.62 16.4339 15.4946C16.6261 15.3692 16.7778 15.1909 16.8708 14.9811C16.9638 14.7713 16.9939 14.5391 16.9577 14.3125C16.9215 14.0859 16.8204 13.8747 16.6667 13.7044ZM9.5001 16.875C9.1326 16.874 8.77442 16.7593 8.47466 16.5467C8.17489 16.3341 7.94822 16.034 7.82573 15.6875H11.1745C11.052 16.034 10.8253 16.3341 10.5255 16.5467C10.2258 16.7593 9.8676 16.874 9.5001 16.875ZM3.21229 14.5C3.23912 14.4751 3.26303 14.4472 3.28354 14.4169L4.3226 12.9206C4.59979 12.5235 4.74895 12.0512 4.7501 11.5669V7.375C4.7501 6.11522 5.25055 4.90704 6.14134 4.01624C7.03214 3.12545 8.24032 2.625 9.5001 2.625C10.7599 2.625 11.9681 3.12545 12.8589 4.01624C13.7497 4.90704 14.2501 6.11522 14.2501 7.375V11.5669C14.2512 12.0512 14.4004 12.5235 14.6776 12.9206L15.7167 14.4169C15.7372 14.4472 15.7611 14.4751 15.7879 14.5H3.21229Z'
        fill={active ? '#00C1D5' : 'black'}
      />
    </svg>
  )
}

export const IconCheckedSuccess = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={27}
      viewBox='0 0 27 27'
      fill='none'
    >
      <circle cx='13.5' cy='13.5' r='13.5' fill='#00E9A1' />
      <path
        d='M11.8129 18.5629C11.3809 18.5629 10.9489 18.3975 10.6199 18.0685L7.24486 14.6935C6.58505 14.0337 6.58505 12.9672 7.24486 12.3074C7.90467 11.6475 8.97117 11.6475 9.63098 12.3074L11.8129 14.4893L17.3699 8.93236C18.0297 8.27255 19.0962 8.27255 19.756 8.93236C20.4158 9.59217 20.4158 10.6587 19.756 11.3185L13.006 18.0685C12.6769 18.3975 12.2449 18.5629 11.8129 18.5629Z'
        fill='white'
      />
    </svg>
  )
}
export const IconCalendar = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={16}
      viewBox='0 0 17 16'
      fill='none'
    >
      <g clipPath='url(#clip0_1526_8641)'>
        <path
          d='M14.5747 3H13.5747V1C13.5747 0.734784 13.4693 0.48043 13.2818 0.292893C13.0943 0.105357 12.8399 0 12.5747 0C12.3095 0 12.0551 0.105357 11.8676 0.292893C11.6801 0.48043 11.5747 0.734784 11.5747 1V3H5.57471V1C5.57471 0.734784 5.46935 0.48043 5.28181 0.292893C5.09428 0.105357 4.83992 0 4.57471 0C4.30949 0 4.05514 0.105357 3.8676 0.292893C3.68006 0.48043 3.57471 0.734784 3.57471 1V3H2.57471C2.04427 3 1.53557 3.21071 1.16049 3.58579C0.785421 3.96086 0.574707 4.46957 0.574707 5L0.574707 14C0.574707 14.5304 0.785421 15.0391 1.16049 15.4142C1.53557 15.7893 2.04427 16 2.57471 16H14.5747C15.1051 16 15.6138 15.7893 15.9889 15.4142C16.364 15.0391 16.5747 14.5304 16.5747 14V5C16.5747 4.46957 16.364 3.96086 15.9889 3.58579C15.6138 3.21071 15.1051 3 14.5747 3ZM2.57471 14V7H14.5747V14H2.57471Z'
          fill='#303538'
        />
      </g>
      <defs>
        <clipPath id='clip0_1526_8641'>
          <rect
            width={16}
            height={16}
            fill='white'
            transform='translate(0.574707)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDescription = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_3726_6735'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={22}
        height={22}
      >
        <path
          d='M0.160156 0.160889H21.8386V21.8394H0.160156V0.160889Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_3726_6735)'>
        <path
          d='M16.6093 13.5059L21.4156 16.0068L10.9998 21.4264L0.583984 16.0068L5.39021 13.506'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <path
        d='M3.1875 12.3553L7.9444 9.88019'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.79102 13.7043L10.5353 11.2358'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.45898 15.0295L18.7478 9.659'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <mask
        id='mask1_3726_6735'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={22}
        height={22}
      >
        <path
          d='M0.160156 0.160889H21.8386V21.8394H0.160156V0.160889Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_3726_6735)'>
        <path
          d='M16.6369 8.51856L21.4156 11.0051L10.9998 16.4247L0.583984 11.0051L5.39021 8.50429'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.8977 4.17337L21.4156 6.00385L10.9998 11.4235L0.583984 6.00385L10.9998 0.584229L14.5176 2.41462'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export const IconSpec = () => {
  return (
    <svg
      width={40}
      height={22}
      viewBox='0 0 40 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.3681 13.5929H27.6687C27.5535 13.9338 27.4159 14.2667 27.257 14.5892L28.4589 15.7911C28.9728 16.3053 28.9728 17.1387 28.4589 17.6528L26.6527 19.4578C26.1315 19.9549 25.3121 19.9549 24.791 19.4578L23.589 18.2558C23.2668 18.4154 22.9343 18.553 22.5937 18.6675V20.3686C22.5927 21.0948 22.0041 21.6834 21.2779 21.6841H18.7231C17.9966 21.6837 17.4076 21.0951 17.4066 20.3686V18.6682C17.066 18.5536 16.7335 18.4161 16.4113 18.2565L15.211 19.4585C14.6898 19.9556 13.8705 19.9556 13.3493 19.4585L11.542 17.6522C11.0289 17.1377 11.0289 16.305 11.542 15.7905L12.744 14.5885C12.5851 14.266 12.4475 13.9331 12.3323 13.5922H10.6329C9.9067 13.5919 9.31774 13.0036 9.31641 12.2774V9.72258C9.31741 8.99607 9.90637 8.40744 10.6329 8.40711H12.3323C12.4475 8.06622 12.5851 7.73334 12.744 7.41082L11.542 6.20886C11.0282 5.69469 11.0282 4.86133 11.542 4.34716L13.3476 2.54155C13.8688 2.0444 14.6882 2.0444 15.2093 2.54155L16.4113 3.74351C16.7335 3.58391 17.066 3.44635 17.4066 3.33183V1.6314C17.4076 0.904877 17.9966 0.316252 18.7231 0.315918H21.2779C22.0044 0.316252 22.5934 0.904877 22.5944 1.6314V3.33183C22.9349 3.44635 23.2675 3.58391 23.5897 3.74351L24.79 2.54155C25.3111 2.0444 26.1305 2.0444 26.6517 2.54155L28.4589 4.34716C28.9721 4.86166 28.9721 5.69435 28.4589 6.20886L27.257 7.41082C27.4159 7.73334 27.5535 8.06622 27.6687 8.40711H29.3681C30.0946 8.40744 30.6836 8.99607 30.6846 9.72258V12.2774C30.6836 13.0039 30.0946 13.5926 29.3681 13.5929ZM29.7554 9.72258C29.7547 9.50924 29.5814 9.33629 29.3681 9.33595H27.3278C27.1211 9.33662 26.9391 9.2004 26.8814 9.00208C26.7355 8.49692 26.5338 8.00946 26.2804 7.54871C26.1796 7.36708 26.2113 7.14038 26.3585 6.99347L27.8012 5.55112C27.9524 5.39987 27.9524 5.15447 27.8012 5.00289L25.9939 3.19761C25.8423 3.04871 25.5993 3.04871 25.4477 3.19761L24.007 4.64197C23.8611 4.78921 23.6351 4.82093 23.4545 4.71976C22.9944 4.46635 22.5076 4.26469 22.0028 4.11878C21.8041 4.06136 21.6672 3.87939 21.6669 3.67239V1.6314C21.6662 1.41805 21.4929 1.24543 21.2796 1.2451H18.7231C18.5097 1.24543 18.3364 1.41805 18.3358 1.6314V3.67272C18.3354 3.87973 18.1986 4.06169 17.9999 4.11912C17.4951 4.26502 17.0083 4.46668 16.5482 4.7201C16.4797 4.75883 16.4026 4.77886 16.3242 4.77819C16.201 4.77786 16.0831 4.72911 15.9956 4.6423L14.5523 3.19962C14.4007 3.05071 14.1576 3.05071 14.0061 3.19962L12.2008 5.00456C12.0495 5.15514 12.0489 5.39987 12.1994 5.55145L12.2008 5.55279L13.6425 6.99347C13.7884 7.13971 13.8204 7.36441 13.7213 7.54537C13.4678 8.00612 13.2662 8.49358 13.1203 8.99874C13.0625 9.19706 12.8805 9.33328 12.6739 9.33262H10.6329C10.4195 9.33295 10.2463 9.5059 10.2456 9.71925V12.2774C10.2463 12.4908 10.4195 12.6637 10.6329 12.664H12.6732C12.8799 12.6634 13.0618 12.7996 13.1196 12.9979C13.2655 13.5031 13.4672 13.9905 13.7206 14.4513C13.8197 14.6323 13.7877 14.857 13.6418 15.0032L12.1991 16.4455C12.0479 16.5968 12.0479 16.8422 12.1991 16.9938L14.0064 18.799C14.158 18.948 14.401 18.948 14.5526 18.799L15.995 17.3564C16.1409 17.2095 16.3666 17.1777 16.5475 17.2786C17.0076 17.532 17.4944 17.7336 17.9992 17.8795C18.1979 17.937 18.3348 18.1189 18.3351 18.3259V20.3686C18.3358 20.582 18.5091 20.7546 18.7224 20.7549H21.2772C21.4906 20.7546 21.6639 20.582 21.6645 20.3686V18.3273C21.6649 18.1203 21.8018 17.9383 22.0004 17.8809C22.5052 17.735 22.992 17.5333 23.4521 17.2799C23.6334 17.1774 23.8611 17.2095 24.007 17.358L25.4504 18.8007C25.602 18.9496 25.845 18.9496 25.9966 18.8007L27.8019 16.9954C27.9531 16.8449 27.9538 16.6001 27.8032 16.4485C27.8029 16.4482 27.8022 16.4475 27.8019 16.4472L26.3592 15.0049C26.2133 14.8586 26.1812 14.6339 26.2804 14.453C26.5338 13.9922 26.7355 13.5047 26.8814 12.9996C26.9391 12.8013 27.1211 12.665 27.3278 12.6657H29.3681C29.5814 12.6654 29.7547 12.4924 29.7554 12.2791V9.72258ZM20.0005 14.8703C17.863 14.869 16.1315 13.1348 16.1329 10.9973C16.1342 8.85985 17.8683 7.12836 20.0058 7.12969C22.1423 7.13103 23.8735 8.86352 23.8735 11C23.8708 13.1375 22.138 14.869 20.0005 14.8703ZM20.0005 8.05921C18.3758 8.05954 17.0594 9.37669 17.0597 11.0013C17.06 12.626 18.3772 13.9425 20.0018 13.9421C21.6265 13.9418 22.943 12.6246 22.9426 11C22.9406 9.37602 21.6245 8.05987 20.0005 8.05854V8.05921Z'
        fill='black'
      />
    </svg>
  )
}
export const IconCompared = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 6.74994H7.1895L5.46975 8.46969C5.39812 8.53887 5.34098 8.62163 5.30167 8.71314C5.26237 8.80464 5.24168 8.90305 5.24081 9.00264C5.23995 9.10222 5.25892 9.20098 5.29663 9.29315C5.33434 9.38533 5.39003 9.46907 5.46045 9.53948C5.53087 9.6099 5.61461 9.66559 5.70678 9.7033C5.79896 9.74102 5.89772 9.75999 5.9973 9.75913C6.09689 9.75826 6.1953 9.73757 6.2868 9.69827C6.37831 9.65896 6.46106 9.60182 6.53025 9.53019L9.53025 6.53019C9.67085 6.38954 9.74984 6.19881 9.74984 5.99994C9.74984 5.80107 9.67085 5.61033 9.53025 5.46969L6.53025 2.46969C6.46106 2.39806 6.37831 2.34092 6.2868 2.30161C6.1953 2.26231 6.09689 2.24162 5.9973 2.24075C5.89772 2.23989 5.79896 2.25886 5.70678 2.29657C5.61461 2.33428 5.53087 2.38997 5.46045 2.46039C5.39003 2.53081 5.33434 2.61455 5.29663 2.70672C5.25892 2.7989 5.23995 2.89766 5.24081 2.99724C5.24168 3.09682 5.26237 3.19524 5.30167 3.28674C5.34098 3.37825 5.39812 3.461 5.46975 3.53019L7.1895 5.24994H1.5C1.30109 5.24994 1.11032 5.32896 0.96967 5.46961C0.829018 5.61026 0.75 5.80103 0.75 5.99994C0.75 6.19885 0.829018 6.38962 0.96967 6.53027C1.11032 6.67092 1.30109 6.74994 1.5 6.74994Z'
        fill='white'
      />
      <path
        d='M16.4998 11.2501H10.8103L12.5301 9.53031C12.6667 9.38886 12.7423 9.19941 12.7406 9.00276C12.7389 8.80611 12.66 8.618 12.521 8.47895C12.3819 8.33989 12.1938 8.26101 11.9971 8.25931C11.8005 8.2576 11.611 8.33319 11.4696 8.46981L8.46959 11.4698C8.32899 11.6105 8.25 11.8012 8.25 12.0001C8.25 12.1989 8.32899 12.3897 8.46959 12.5303L11.4696 15.5303C11.611 15.6669 11.8005 15.7425 11.9971 15.7408C12.1938 15.7391 12.3819 15.6602 12.521 15.5212C12.66 15.3821 12.7389 15.194 12.7406 14.9974C12.7423 14.8007 12.6667 14.6113 12.5301 14.4698L10.8103 12.7501H16.4998C16.6988 12.7501 16.8895 12.671 17.0302 12.5304C17.1708 12.3897 17.2498 12.199 17.2498 12.0001C17.2498 11.8011 17.1708 11.6104 17.0302 11.4697C16.8895 11.3291 16.6988 11.2501 16.4998 11.2501Z'
        fill='white'
      />
    </svg>
  )
}

export const IconRating = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3726_6762)'>
        <path
          d='M9.97131 17.4743L7.98898 22.8247L6.86142 21.2176C6.817 21.1543 6.75409 21.1063 6.68132 21.0801C6.60855 21.0539 6.52947 21.0509 6.45492 21.0715L4.54331 21.5978L6.67451 15.8455C6.56507 15.6521 6.47293 15.4494 6.39917 15.2398C6.3858 15.2043 6.36968 15.161 6.35357 15.1199C6.28827 15.1069 6.2227 15.0951 6.15724 15.0829L3.58584 22.0232C3.56188 22.0879 3.55623 22.158 3.56952 22.2257C3.58281 22.2934 3.61452 22.3561 3.66117 22.407C3.70781 22.4578 3.76758 22.4948 3.83389 22.5139C3.9002 22.533 3.97049 22.5334 4.03701 22.5151L6.39926 21.8647L7.78546 23.8404C7.82475 23.8963 7.87859 23.9405 7.94117 23.9681C8.00375 23.9957 8.07268 24.0056 8.14051 23.9968C8.20833 23.9881 8.27246 23.9609 8.32597 23.9183C8.37948 23.8757 8.42033 23.8193 8.44409 23.7552L10.7171 17.6203C10.6027 17.6262 10.488 17.6198 10.3749 17.6013C10.2355 17.5765 10.0998 17.5338 9.97131 17.4743Z'
          fill='black'
        />
        <path
          d='M17.8426 15.083C17.7771 15.0952 17.7114 15.107 17.6461 15.1201C17.6299 15.1611 17.6138 15.2043 17.6005 15.2398C17.5267 15.4494 17.4347 15.6521 17.3253 15.8454L19.4565 21.5978L17.5449 21.0714C17.4703 21.051 17.3913 21.054 17.3185 21.0802C17.2458 21.1063 17.1829 21.1543 17.1384 21.2176L16.0108 22.8247L14.0285 17.4742C13.8999 17.5338 13.7642 17.5765 13.6247 17.6013C13.5331 17.6172 13.4404 17.6252 13.3475 17.6251C13.3256 17.6251 13.3048 17.6224 13.2832 17.6216L15.5557 23.7552C15.5795 23.8193 15.6203 23.8757 15.6738 23.9183C15.7274 23.9609 15.7915 23.988 15.8593 23.9968C15.9271 24.0056 15.9961 23.9956 16.0586 23.9681C16.1212 23.9405 16.1751 23.8963 16.2144 23.8404L17.6006 21.8647L19.9628 22.5151C20.0293 22.5334 20.0996 22.533 20.1659 22.5139C20.2322 22.4948 20.292 22.4578 20.3386 22.407C20.3853 22.3561 20.417 22.2934 20.4303 22.2257C20.4436 22.158 20.4379 22.0879 20.414 22.0232L17.8426 15.083Z'
          fill='black'
        />
        <path
          d='M13.4967 16.862C13.8561 16.7984 14.1196 16.5127 14.353 16.2417C14.4554 16.0998 14.5843 15.979 14.7326 15.8862C14.9115 15.861 15.0936 15.8709 15.2688 15.9153C15.6047 15.9707 15.9858 16.0337 16.3123 15.8464C16.6428 15.6569 16.7788 15.2951 16.8986 14.9759C16.9461 14.8064 17.0264 14.6477 17.1349 14.509C17.2931 14.4259 17.466 14.3743 17.6439 14.3572C17.9802 14.2955 18.3615 14.2257 18.606 13.937C18.8509 13.6481 18.8546 13.263 18.8578 12.9232C18.8441 12.7469 18.8654 12.5696 18.9204 12.4015C19.0396 12.2718 19.1828 12.1664 19.342 12.0911C19.6387 11.9184 19.975 11.7226 20.1066 11.3647C20.2361 11.0118 20.1068 10.6503 19.9928 10.3313C19.9182 10.1688 19.8765 9.99305 19.8703 9.81432C19.9368 9.65514 20.0335 9.51026 20.1548 9.38759C20.3752 9.12292 20.625 8.82281 20.625 8.43747C20.625 8.05213 20.3752 7.75202 20.1548 7.48734C20.0334 7.36463 19.9368 7.21973 19.8701 7.06053C19.8765 6.88179 19.9182 6.70609 19.9927 6.54353C20.1067 6.22456 20.2361 5.86312 20.1065 5.51018C19.975 5.1523 19.6386 4.95657 19.3419 4.78381C19.1827 4.70856 19.0396 4.60327 18.9204 4.47372C18.8655 4.30559 18.8442 4.1283 18.8579 3.95196C18.8547 3.61221 18.851 3.22705 18.6061 2.93802C18.3616 2.64945 17.9803 2.5795 17.6441 2.5178C17.4661 2.50069 17.2932 2.44913 17.135 2.366C17.0265 2.22733 16.9463 2.06873 16.8988 1.89918C16.7789 1.58003 16.643 1.21822 16.3124 1.02862C15.986 0.84121 15.6051 0.904291 15.2689 0.95977C15.0937 1.00419 14.9116 1.01405 14.7327 0.988792C14.5843 0.895929 14.4554 0.775204 14.353 0.633292C14.1291 0.37319 13.8754 0.078391 13.4968 0.0126573C13.1294 -0.0511546 12.7953 0.136344 12.5009 0.301687C12.3496 0.404672 12.1793 0.476616 12 0.513355C11.8207 0.476616 11.6504 0.404672 11.4991 0.301687C11.2047 0.136435 10.8719 -0.050789 10.5033 0.0126573C10.1246 0.078391 9.87094 0.37319 9.647 0.633282C9.54461 0.775167 9.41571 0.895888 9.26743 0.988782C9.0885 1.01428 8.90631 1.00439 8.7312 0.959669C8.3952 0.90428 8.01435 0.841201 7.68769 1.02852C7.35718 1.21803 7.22122 1.57984 7.10137 1.899C7.05387 2.06858 6.97359 2.22721 6.86508 2.36591C6.70688 2.44904 6.53402 2.5006 6.35613 2.51771C6.01977 2.57941 5.63854 2.64927 5.39401 2.93793C5.1491 3.22687 5.14544 3.61194 5.14224 3.95169C5.1559 4.12803 5.13462 4.30534 5.07961 4.47345C4.96041 4.60312 4.81724 4.70851 4.65801 4.78381C4.36129 4.95657 4.02501 5.1523 3.89345 5.51027C3.7639 5.86311 3.89318 6.22465 4.00725 6.54362C4.08185 6.70617 4.12348 6.88188 4.12975 7.06062C4.06315 7.2198 3.96655 7.36467 3.8452 7.48734C3.62485 7.75202 3.375 8.05214 3.375 8.43747C3.375 8.8228 3.62485 9.12292 3.84521 9.3876C3.96657 9.51031 4.06321 9.65521 4.12985 9.81441C4.1235 9.99315 4.08184 10.1689 4.00726 10.3314C3.89328 10.6504 3.76392 11.0118 3.89346 11.3648C4.02503 11.7226 4.36139 11.9184 4.65811 12.0911C4.81728 12.1664 4.9604 12.2717 5.07961 12.4012C5.13452 12.5693 5.15577 12.7466 5.14214 12.923C5.14535 13.2627 5.14901 13.6479 5.39391 13.9369C5.63845 14.2255 6.01968 14.2954 6.35595 14.3571C6.53387 14.3743 6.70675 14.4258 6.86498 14.5089C6.97347 14.6476 7.05371 14.8062 7.10119 14.9758C7.22112 15.2949 7.35699 15.6567 7.68758 15.8463C8.01406 16.0337 8.39492 15.9707 8.7311 15.9152C8.90623 15.8706 9.0884 15.8607 9.26732 15.8862C9.41566 15.979 9.54459 16.0997 9.64699 16.2417C9.87093 16.5018 10.1246 16.7965 10.5032 16.8623C10.8704 16.9254 11.2046 16.7386 11.4991 16.5732C11.6504 16.4703 11.8207 16.3983 12 16.3616C12.1793 16.3983 12.3496 16.4703 12.5009 16.5733C12.8026 16.7427 13.138 16.9254 13.4967 16.862ZM12.868 15.9193C12.6097 15.7444 12.3109 15.6384 12 15.6116C11.6891 15.6384 11.3903 15.7444 11.132 15.9193C10.9557 16.0184 10.7377 16.1423 10.6315 16.1233C10.5178 16.1036 10.3501 15.9089 10.2155 15.7524C10.037 15.5057 9.79823 15.3089 9.52204 15.1807C9.22302 15.1014 8.90875 15.0995 8.6088 15.1752C8.40692 15.2087 8.15542 15.2501 8.06067 15.1958C7.96417 15.1405 7.875 14.9029 7.80332 14.7121C7.72021 14.4171 7.56231 14.1486 7.34491 13.9325C7.09168 13.7572 6.79784 13.6494 6.49127 13.6194C6.28903 13.5823 6.03745 13.5362 5.96613 13.4521C5.89646 13.3697 5.89408 13.1182 5.89215 12.9159C5.91531 12.6091 5.85854 12.3015 5.72736 12.0232C5.55015 11.7738 5.3119 11.574 5.0354 11.4429C4.85733 11.3393 4.63577 11.2103 4.59751 11.1062C4.56171 11.0085 4.64584 10.7732 4.7135 10.584C4.84203 10.3024 4.8954 9.99232 4.86841 9.68396C4.78886 9.39105 4.63496 9.12367 4.42163 8.90777C4.28952 8.74902 4.125 8.55145 4.125 8.43747C4.125 8.32349 4.28952 8.12592 4.42163 7.96717C4.63495 7.75127 4.78886 7.48389 4.8684 7.19099C4.89536 6.88266 4.84199 6.5726 4.71349 6.29103C4.64584 6.10188 4.56161 5.8665 4.5975 5.76891C4.63577 5.66463 4.85732 5.53563 5.0354 5.432C5.3119 5.30089 5.55015 5.10104 5.72735 4.85156C5.85861 4.57325 5.91542 4.26566 5.89224 3.95883C5.89416 3.75659 5.89654 3.50501 5.96621 3.42279C6.03753 3.33866 6.28921 3.29251 6.49145 3.25544C6.79799 3.22547 7.09179 3.11769 7.345 2.94233C7.56236 2.72625 7.72028 2.45774 7.8035 2.16276C7.87518 1.97197 7.96435 1.73439 8.06085 1.67909C8.15543 1.62462 8.40674 1.66628 8.60889 1.69969C8.90881 1.7753 9.22303 1.77345 9.52203 1.69429C9.79822 1.56604 10.037 1.36921 10.2155 1.12255C10.3501 0.966084 10.5178 0.771359 10.6316 0.751672C10.7348 0.732995 10.9555 0.856591 11.132 0.955649C11.3903 1.13059 11.6891 1.23652 12 1.26335C12.3109 1.23652 12.6097 1.13059 12.868 0.955638C13.0444 0.85667 13.2626 0.73225 13.3685 0.75166C13.4822 0.771348 13.6499 0.966076 13.7845 1.12254C13.963 1.3692 14.2018 1.56603 14.478 1.69428C14.777 1.77337 15.0912 1.77526 15.3912 1.69977C15.5931 1.66617 15.8445 1.6247 15.9393 1.67917C16.0358 1.73447 16.125 1.97205 16.1967 2.16284C16.2798 2.45785 16.4377 2.72638 16.6551 2.94241C16.9083 3.11778 17.2022 3.22555 17.5087 3.25552C17.711 3.2926 17.9626 3.33874 18.0339 3.42288C18.1035 3.50519 18.1059 3.75677 18.1078 3.95901C18.0847 4.26582 18.1415 4.5734 18.2726 4.85173C18.4499 5.10116 18.6881 5.30095 18.9646 5.43199C19.1427 5.53562 19.3642 5.66462 19.4025 5.76872C19.4383 5.86641 19.3542 6.10178 19.2865 6.29093C19.158 6.57253 19.1046 6.88262 19.1316 7.19098C19.2111 7.48389 19.365 7.75126 19.5784 7.96716C19.7105 8.12591 19.875 8.32348 19.875 8.43746C19.875 8.55145 19.7105 8.74901 19.5784 8.90777C19.365 9.12367 19.2111 9.39104 19.1316 9.68395C19.1046 9.99228 19.158 10.3023 19.2865 10.5839C19.3542 10.7731 19.4384 11.0084 19.4025 11.106C19.3642 11.2103 19.1427 11.3393 18.9646 11.4429C18.6881 11.574 18.4498 11.7739 18.2726 12.0234C18.1414 12.3017 18.0846 12.6093 18.1078 12.9161C18.1058 13.1184 18.1035 13.3699 18.0338 13.4522C17.9625 13.5363 17.7108 13.5824 17.5085 13.6195C17.202 13.6495 16.9082 13.7572 16.655 13.9326C16.4376 14.1487 16.2797 14.4172 16.1965 14.7122C16.1248 14.903 16.0356 15.1406 15.9391 15.1959C15.8443 15.2502 15.593 15.2085 15.3911 15.1753C15.0912 15.0996 14.777 15.1015 14.478 15.1807C14.2018 15.3089 13.963 15.5057 13.7845 15.7524C13.6499 15.9089 13.4822 16.1036 13.3684 16.1233C13.2658 16.142 13.0445 16.0184 12.868 15.9193Z'
          fill='black'
        />
        <path
          d='M17.25 8.43753C17.25 7.39918 16.9421 6.38414 16.3652 5.52078C15.7884 4.65742 14.9684 3.98451 14.0091 3.58714C13.0498 3.18978 11.9942 3.08581 10.9758 3.28838C9.95739 3.49095 9.02193 3.99096 8.2877 4.72518C7.55347 5.45941 7.05346 6.39487 6.85088 7.41327C6.64831 8.43167 6.75227 9.48727 7.14963 10.4466C7.54699 11.4059 8.2199 12.2258 9.08326 12.8027C9.94661 13.3796 10.9616 13.6875 12 13.6875C13.3919 13.6859 14.7264 13.1323 15.7106 12.1481C16.6948 11.1639 17.2484 9.82944 17.25 8.43753ZM12 12.9375C11.11 12.9375 10.24 12.6736 9.49996 12.1791C8.75995 11.6847 8.18318 10.9818 7.84259 10.1596C7.502 9.33732 7.41289 8.43253 7.58653 7.55963C7.76016 6.68672 8.18874 5.8849 8.81808 5.25557C9.44741 4.62624 10.2492 4.19766 11.1221 4.02403C11.995 3.8504 12.8998 3.93952 13.7221 4.28011C14.5444 4.6207 15.2472 5.19747 15.7416 5.93749C16.2361 6.6775 16.5 7.54752 16.5 8.43753C16.4987 9.6306 16.0241 10.7744 15.1805 11.618C14.3369 12.4617 13.1931 12.9362 12 12.9375Z'
          fill='black'
        />
        <path
          d='M15.1696 7.51564C15.148 7.44866 15.1081 7.38909 15.0543 7.34373C15.0005 7.29836 14.9351 7.26904 14.8654 7.25911L13.1161 7.00963L12.335 5.45654C12.3038 5.39445 12.256 5.34226 12.1968 5.30579C12.1376 5.26931 12.0695 5.25 12 5.25C11.9305 5.25 11.8624 5.26931 11.8033 5.30579C11.7441 5.34226 11.6962 5.39445 11.665 5.45654L10.8839 7.00963L9.13461 7.25911C9.06495 7.26903 8.99948 7.29835 8.9457 7.34372C8.89191 7.38909 8.85198 7.44868 8.83046 7.51567C8.80894 7.58267 8.80671 7.65436 8.82402 7.72257C8.84133 7.79077 8.87748 7.85273 8.92834 7.90135L10.1899 9.10819L9.89239 10.8104C9.88035 10.8792 9.88777 10.95 9.9138 11.0148C9.93982 11.0796 9.98343 11.1358 10.0397 11.1772C10.096 11.2185 10.1627 11.2434 10.2323 11.2488C10.3019 11.2543 10.3717 11.2403 10.4337 11.2082L12 10.4001L13.5663 11.2082C13.6286 11.2395 13.6982 11.2531 13.7677 11.2477C13.8371 11.2422 13.9038 11.2178 13.9603 11.1772C14.0166 11.1358 14.0602 11.0796 14.0862 11.0148C14.1122 10.95 14.1197 10.8792 14.1077 10.8104L13.8101 9.1082L15.0717 7.90135C15.1225 7.85271 15.1587 7.79074 15.176 7.72254C15.1933 7.65434 15.1911 7.58264 15.1696 7.51564ZM13.1471 8.70454C13.1026 8.74711 13.0692 8.79999 13.05 8.85852C13.0308 8.91704 13.0263 8.9794 13.0369 9.04008L13.2387 10.1953L12.172 9.64487C12.1185 9.61845 12.0597 9.6047 12 9.6047C11.9404 9.6047 11.8815 9.61845 11.8281 9.64487L10.7613 10.1953L10.9632 9.04008C10.9738 8.9794 10.9693 8.91704 10.9501 8.85852C10.9308 8.79999 10.8975 8.74711 10.853 8.70454L10.0043 7.89266L11.1838 7.72447C11.2437 7.71594 11.3007 7.69304 11.3498 7.65772C11.3989 7.62241 11.4387 7.57573 11.4659 7.52168L12 6.45968L12.5341 7.52168C12.5613 7.57574 12.6011 7.62241 12.6503 7.65773C12.6994 7.69304 12.7563 7.71594 12.8162 7.72447L13.9958 7.89266L13.1471 8.70454Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3726_6762'>
          <rect width={24} height={24} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CouponArrowDown = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.00041 11.0006C7.73521 11.0005 7.4809 10.8951 7.29341 10.7076L3.29341 6.70757C3.11125 6.51897 3.01045 6.26636 3.01273 6.00417C3.01501 5.74197 3.12018 5.49116 3.30559 5.30575C3.491 5.12034 3.74181 5.01517 4.00401 5.0129C4.2662 5.01062 4.5188 5.11141 4.70741 5.29357L8.00041 8.58657L11.2934 5.29357C11.3857 5.19806 11.496 5.12188 11.618 5.06947C11.74 5.01706 11.8712 4.98947 12.004 4.98832C12.1368 4.98717 12.2685 5.01247 12.3914 5.06275C12.5143 5.11303 12.6259 5.18728 12.7198 5.28117C12.8137 5.37507 12.8879 5.48672 12.9382 5.60962C12.9885 5.73251 13.0138 5.86419 13.0127 5.99697C13.0115 6.12975 12.9839 6.26097 12.9315 6.38297C12.8791 6.50498 12.8029 6.61532 12.7074 6.70757L8.70741 10.7076C8.51991 10.8951 8.2656 11.0005 8.00041 11.0006Z'
        fill='#303538'
      />
    </svg>
  )
}
export const CouponIconSimple = () => {
  return (
    <svg
      width={28}
      height={20}
      viewBox='0 0 28 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24.7708 19.8594H2.56252C1.14948 19.8594 0 18.7459 0 17.377V13.2396C0 12.7822 0.382028 12.4121 0.854172 12.4121C2.26721 12.4121 3.41669 11.2986 3.41669 9.9297C3.41669 8.56081 2.26721 7.44726 0.854172 7.44726C0.382028 7.44731 0 7.07722 0 6.61983V2.48244C0 1.11356 1.14948 0 2.56252 0H24.7709C26.1839 0 27.3334 1.11356 27.3334 2.48244V6.61983C27.3334 7.07722 26.9514 7.44731 26.4792 7.44731C25.0662 7.44731 23.9167 8.56087 23.9167 9.92975C23.9167 11.2986 25.0662 12.4122 26.4792 12.4122C26.9514 12.4122 27.3334 12.7823 27.3334 13.2397V17.3771C27.3333 18.7459 26.1839 19.8594 24.7708 19.8594ZM1.70834 13.9839V17.377C1.70834 17.8336 2.09123 18.2045 2.56252 18.2045H24.7709C25.2422 18.2045 25.625 17.8336 25.625 17.377V13.9839C23.6782 13.5992 22.2084 11.9281 22.2084 9.9297C22.2084 7.93128 23.6781 6.26022 25.625 5.87553V2.48244C25.625 2.02588 25.2422 1.65496 24.7709 1.65496H2.56252C2.09123 1.65496 1.70834 2.02588 1.70834 2.48244V5.87559C3.65523 6.26022 5.12503 7.93133 5.12503 9.92975C5.12503 11.9282 3.65523 13.5992 1.70834 13.9839Z'
        fill='black'
      />
      <path
        d='M10.3047 16.248L15.4279 3.01315L17.0274 3.59423L11.9042 16.8291L10.3047 16.248Z'
        fill='black'
      />
      <path
        d='M9.62502 10.2071C8.21198 10.2071 7.0625 9.09351 7.0625 7.72462C7.0625 6.35574 8.21198 5.24219 9.62502 5.24219C11.0381 5.24219 12.1875 6.35574 12.1875 7.72462C12.1875 9.09351 11.0381 10.2071 9.62502 10.2071ZM9.62502 6.89715C9.15374 6.89715 8.77084 7.26807 8.77084 7.72462C8.77084 8.18118 9.15374 8.5521 9.62502 8.5521C10.0963 8.5521 10.4792 8.18118 10.4792 7.72462C10.4792 7.26807 10.0963 6.89715 9.62502 6.89715Z'
        fill='black'
      />
      <path
        d='M18.4551 15.3399C17.0421 15.3399 15.8926 14.2263 15.8926 12.8574C15.8926 11.4886 17.0421 10.375 18.4551 10.375C19.8681 10.375 21.0176 11.4886 21.0176 12.8574C21.0176 14.2263 19.8681 15.3399 18.4551 15.3399ZM18.4551 12.03C17.9838 12.03 17.6009 12.4009 17.6009 12.8574C17.6009 13.314 17.9838 13.6849 18.4551 13.6849C18.9264 13.6849 19.3093 13.314 19.3093 12.8574C19.3093 12.4009 18.9264 12.03 18.4551 12.03Z'
        fill='black'
      />
    </svg>
  )
}
export const Policy1 = () => {
  return (
    <svg
      width={37}
      height={28}
      viewBox='0 0 37 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.13935 4.63159C7.7433 4.63159 7.42188 4.95302 7.42188 5.34907C7.42188 5.74511 7.7433 6.06654 8.13935 6.06654C8.5354 6.06654 8.85683 5.74511 8.85683 5.34907C8.85683 4.95302 8.5354 4.63159 8.13935 4.63159Z'
        fill='#00C1D5'
      />
      <path
        d='M34.0377 10.767L32.9996 8.69072C32.6325 7.9566 31.8949 7.50064 31.0744 7.50064H25.0736V2.47853C25.0736 1.29175 24.1081 0.326172 22.9213 0.326172H2.40235C1.21551 0.326172 0.25 1.29168 0.25 2.47853V21.1321C0.25 22.3189 1.21551 23.2845 2.40235 23.2845H4.55471C4.55471 24.3861 4.9712 25.392 5.65431 26.1542H0.967475C0.571214 26.1542 0.25 26.4755 0.25 26.8717C0.25 27.2679 0.571214 27.5892 0.967475 27.5892H36.2658C36.6621 27.5892 36.9833 27.2679 36.9833 26.8717C36.9833 26.4755 36.6621 26.1542 36.2658 26.1542H34.4488C35.1319 25.392 35.5484 24.3861 35.5484 23.2845C35.5484 23.2436 35.5464 23.2029 35.5453 23.1621C36.3819 22.8667 36.9832 22.0686 36.9832 21.1321V17.166C36.9832 16.3288 37.149 17.1104 34.0377 10.767ZM32.9526 11.8053L35.105 16.11H27.9434V11.8053H32.9526ZM1.68488 17.5449H3.11976V18.9797H1.68488V17.5449ZM8.85935 26.1542C7.27696 26.1542 5.98959 24.8668 5.98959 23.2845C5.98959 23.089 6.00896 22.8967 6.0477 22.7096C6.31755 21.3798 7.50002 20.4146 8.85935 20.4146C10.2187 20.4146 11.4012 21.3798 11.671 22.7096C11.6712 22.7107 11.6714 22.7116 11.6716 22.7126C11.7098 22.8966 11.7291 23.089 11.7291 23.2845C11.7291 24.8668 10.4417 26.1542 8.85935 26.1542ZM8.85935 18.9797C7.0211 18.9797 5.39882 20.1573 4.80073 21.8495H2.40235C2.00674 21.8495 1.68488 21.5276 1.68488 21.132V20.4146H3.83723C4.2335 20.4146 4.55471 20.0933 4.55471 19.6971V16.8273C4.55471 16.4311 4.2335 16.1098 3.83723 16.1098H1.68488V2.47853C1.68488 2.08291 2.00674 1.76105 2.40235 1.76105H22.9213C23.3169 1.76105 23.6388 2.08291 23.6388 2.47853C23.6388 3.01226 23.6388 20.129 23.6388 21.8496H12.9176C12.3184 20.1565 10.6968 18.9797 8.85935 18.9797ZM12.0644 26.1542C12.7476 25.392 13.164 24.3861 13.164 23.2845C13.7149 23.2845 26.7044 23.2845 26.9389 23.2845C26.9389 24.3861 27.3554 25.392 28.0385 26.1542H12.0644ZM31.2436 26.1542C29.6613 26.1542 28.3739 24.8668 28.3739 23.2845C28.3739 23.089 28.3933 22.8967 28.432 22.7096C28.7018 21.3798 29.8843 20.4146 31.2436 20.4146C32.603 20.4146 33.7855 21.3798 34.0553 22.7096C34.0555 22.7107 34.0557 22.7116 34.0559 22.7126C34.0941 22.8966 34.1134 23.089 34.1134 23.2845C34.1135 24.8668 32.826 26.1542 31.2436 26.1542ZM35.5484 21.1321C35.5484 21.3707 35.4308 21.5819 35.251 21.7125C34.6146 20.0932 33.0311 18.9798 31.2436 18.9798C29.4054 18.9798 27.7831 20.1574 27.185 21.8496H25.0736V8.93552H31.0743C31.3478 8.93552 31.5937 9.08762 31.7161 9.33235L32.2351 10.3704H27.226C26.8297 10.3704 26.5085 10.6917 26.5085 11.0879V16.8275C26.5085 17.2237 26.8297 17.5449 27.226 17.5449H35.5484V21.1321Z'
        fill='#010103'
      />
      <path
        d='M20.0542 4.63159H11.0144C10.6181 4.63159 10.2969 4.95288 10.2969 5.34907C10.2969 5.74526 10.6181 6.06654 11.0144 6.06654H20.0542C20.4504 6.06654 20.7717 5.74526 20.7717 5.34907C20.7717 4.95288 20.4504 4.63159 20.0542 4.63159Z'
        fill='#00C1D5'
      />
      <path
        d='M20.0516 7.50024H13.8815C13.4853 7.50024 13.1641 7.82153 13.1641 8.21772C13.1641 8.61391 13.4853 8.9352 13.8815 8.9352H20.0516C20.4479 8.9352 20.7691 8.61391 20.7691 8.21772C20.7691 7.82153 20.4478 7.50024 20.0516 7.50024Z'
        fill='#00C1D5'
      />
      <path
        d='M31.2474 21.8477C30.4561 21.8477 29.8125 22.4914 29.8125 23.2825C29.8125 24.0738 30.4562 24.7174 31.2474 24.7174C32.0386 24.7174 32.6823 24.0737 32.6823 23.2825C32.6823 22.4913 32.0386 21.8477 31.2474 21.8477Z'
        fill='#010103'
      />
      <path
        d='M8.85675 21.8474C8.06552 21.8474 7.42188 22.4911 7.42188 23.2823C7.42188 24.0735 8.06559 24.7172 8.85675 24.7172C9.64799 24.7172 10.2916 24.0735 10.2916 23.2823C10.2916 22.4911 9.64799 21.8474 8.85675 21.8474Z'
        fill='#010103'
      />
    </svg>
  )
}

export const Policy2 = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25.8643 0.804688C26.0397 0.742176 26.2384 0.785753 26.3721 0.920898L27.248 1.80371C27.3818 1.9384 27.4232 2.13656 27.3604 2.31055L27.3271 2.38281L26.0537 4.6582L26.0527 4.65723C26.0114 4.73168 25.9525 4.7944 25.8799 4.83789L24.4482 5.69531L12.5713 17.3105L12.7881 17.5283C13.1531 17.8966 13.2592 18.2075 13.1738 18.5049C13.133 18.647 13.0514 18.7769 12.9521 18.8984C12.853 19.0198 12.7312 19.1398 12.6084 19.2617L5.16406 26.6455C4.79648 27.0108 4.30687 27.2225 3.81836 27.2227C3.40004 27.2227 3.01244 27.0675 2.73047 26.7832L1.04102 25.0811C0.724704 24.7624 0.576978 24.3242 0.618164 23.8525L0.640625 23.6855C0.711334 23.3006 0.905923 22.937 1.19824 22.6475L8.69629 15.21C8.86207 15.045 9.00321 14.9037 9.1416 14.8057C9.28367 14.7051 9.42957 14.6455 9.60547 14.6455C9.8973 14.6456 10.1082 14.8261 10.2588 14.9775L10.5977 15.3193L22.4736 3.70508L23.3584 2.26562C23.4017 2.19435 23.463 2.13613 23.5352 2.0957L25.791 0.838867L25.8643 0.804688ZM1.88281 23.3369C1.70834 23.5098 1.60475 23.724 1.58594 23.9365C1.56888 24.1265 1.62432 24.2877 1.73145 24.3955L3.41992 26.0986C3.54245 26.2222 3.70049 26.251 3.81836 26.251C4.04682 26.2508 4.2889 26.1459 4.48047 25.9561L12.1729 18.3027L9.59766 15.6934L1.88281 23.3369ZM11.2812 16.0098L11.8887 16.6201L23.457 5.30469L22.8516 4.69336L11.2812 16.0098ZM24.1182 2.88281L23.4707 3.93848L24.2236 4.69727L25.2686 4.07129L26.3008 2.22852L25.9414 1.86621L24.1182 2.88281Z'
        fill='black'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M8.1709 19.2017C8.29332 19.2113 8.4053 19.2707 8.4873 19.354C8.56928 19.4373 8.62717 19.5502 8.63574 19.6724C8.64439 19.7971 8.60108 19.9256 8.49316 20.0327C8.4763 20.0495 7.75527 20.7646 7.03613 21.478C6.67358 21.8377 6.31065 22.1969 6.03906 22.4663C5.9034 22.6009 5.79007 22.713 5.71094 22.7915C5.67147 22.8307 5.64032 22.8613 5.61914 22.8823L5.58691 22.9146C5.47869 23.0225 5.35049 23.0651 5.22559 23.0552C5.10339 23.0454 4.99125 22.986 4.90918 22.9028C4.82728 22.8197 4.7696 22.7074 4.76074 22.5854C4.75176 22.4608 4.79464 22.333 4.90234 22.2261L4.9043 22.2241C4.90644 22.222 4.91765 22.2116 4.9375 22.1919C4.95923 22.1704 4.99036 22.1387 5.03027 22.0991C5.11044 22.0196 5.22487 21.9064 5.36133 21.771C5.63419 21.5003 5.99691 21.1404 6.35938 20.7808C6.72174 20.4213 7.08392 20.0619 7.35547 19.7925C7.49118 19.6578 7.60441 19.5449 7.68359 19.4663C7.72319 19.427 7.75516 19.3965 7.77637 19.3755C7.78686 19.3651 7.79434 19.3565 7.7998 19.3511C7.80254 19.3484 7.80525 19.3466 7.80664 19.3452L7.80762 19.3433H7.80859C7.91735 19.2352 8.0458 19.1919 8.1709 19.2017Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M9.4375 17.8025C9.62607 17.6789 9.88192 17.6993 10.0479 17.866C10.2369 18.0561 10.2359 18.3645 10.0459 18.5535L9.91602 18.6833C9.82175 18.7771 9.69707 18.824 9.57324 18.824C9.44832 18.8239 9.32352 18.7764 9.22852 18.6814C9.03949 18.4913 9.0405 18.1828 9.23047 17.9939L9.36133 17.864L9.4375 17.8025Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M3.58887 23.5935C3.77986 23.4046 4.08696 23.4079 4.27539 23.5974L4.33691 23.6736C4.46093 23.8628 4.43943 24.1198 4.27246 24.2849L4.1416 24.4138C3.97518 24.5788 3.71779 24.5968 3.53027 24.4724L3.45508 24.4109C3.26635 24.22 3.26739 23.912 3.45801 23.7234L3.58789 23.5935H3.58887Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M7.91113 9.89429L8.02637 9.8894C8.14126 9.8985 8.25134 9.94908 8.33398 10.033L11.4717 13.2117C11.5795 13.3208 11.6225 13.4498 11.6123 13.575C11.6022 13.6972 11.5424 13.8086 11.459 13.8904C11.3755 13.9722 11.2629 14.0296 11.1406 14.0378C11.0157 14.0463 10.8873 14.0027 10.7803 13.8943V13.8933C10.7502 13.8629 10.0125 13.1166 9.27734 12.3718C8.90315 11.9928 8.52938 11.6138 8.24902 11.3298C8.10891 11.1879 7.9919 11.0699 7.91016 10.9871C7.87043 10.9468 7.83922 10.9145 7.81738 10.8923L5.70312 11.2312L5.5 11.2703C4.49134 11.4403 3.57207 11.2376 2.78906 10.6589C1.74663 9.88858 1.14673 8.58983 0.805664 7.47925C0.463708 6.36559 0.37601 5.42221 0.369141 5.34253L0.370117 5.34155C0.369372 5.33273 0.3685 5.32511 0.369141 5.31909C0.369539 5.31542 0.370627 5.31188 0.371094 5.30933V5.32007C0.366786 5.19916 0.411645 5.06926 0.493164 4.97827L0.491211 4.98022C0.492259 4.97846 0.494515 4.97674 0.496094 4.97437C0.499374 4.96947 0.504803 4.96274 0.511719 4.95581V4.95483L1.44336 4.03491L1.52051 3.97339C1.70974 3.85016 1.96605 3.87225 2.13086 4.03882L4.50195 6.44214L6.29199 6.19507L6.56152 4.40796L4.19043 2.00562C4.00223 1.8146 4.00408 1.50749 4.19434 1.31909H4.19531L5.12695 0.39917L5.12988 0.395264C5.13632 0.389485 5.14289 0.385439 5.14746 0.382568C5.15156 0.380009 5.15549 0.378102 5.15625 0.377686C5.25083 0.298076 5.39125 0.248939 5.5166 0.261475C5.60018 0.269809 6.54133 0.369591 7.64844 0.725342C8.75422 1.08069 10.0441 1.69692 10.8008 2.74878C11.4058 3.59024 11.5824 4.58081 11.332 5.68335L11.333 5.68433L10.9697 7.78003L13.9395 10.7878C14.0472 10.897 14.0903 11.026 14.0801 11.1511C14.07 11.2734 14.0102 11.3848 13.9268 11.4666C13.8433 11.5483 13.7306 11.6059 13.6084 11.614C13.4834 11.6223 13.355 11.5781 13.248 11.4695V11.4685L13.2109 11.4314C13.1873 11.4074 13.1528 11.3728 13.1094 11.3289C13.0226 11.2409 12.8995 11.116 12.752 10.9666C12.4565 10.6673 12.0632 10.2692 11.6709 9.87183C11.2788 9.47467 10.8875 9.07756 10.5938 8.78003C10.4469 8.63132 10.3239 8.50741 10.2383 8.42065C10.1955 8.37735 10.1616 8.3433 10.1387 8.32007C10.1272 8.30845 10.1182 8.29873 10.1123 8.29272L10.1035 8.28394C9.99348 8.17222 9.94367 8.01362 9.9707 7.85913L10.3799 5.4978L10.3809 5.49292L10.4395 5.17651C10.5411 4.45595 10.3982 3.8521 10.0137 3.31714C9.47983 2.57353 8.55766 2.0798 7.66797 1.75952C6.81914 1.45396 6.01419 1.31158 5.63965 1.25659L5.22363 1.66772L7.4248 3.89819L7.42676 3.90015C7.43524 3.90919 7.44054 3.91915 7.44434 3.92554V3.92651C7.50868 4.00151 7.55309 4.10443 7.5625 4.20874L7.55957 4.31226C7.55957 4.31226 7.55974 4.31308 7.55957 4.31421C7.55937 4.31551 7.55895 4.31771 7.55859 4.32007C7.55786 4.32493 7.55703 4.33253 7.55566 4.34155C7.55295 4.3595 7.54885 4.38524 7.54395 4.41772C7.534 4.4836 7.51978 4.57759 7.50293 4.68921C7.46924 4.91244 7.42452 5.2088 7.37988 5.50464C7.33525 5.80042 7.29025 6.09569 7.25684 6.31714C7.24015 6.42773 7.22654 6.52016 7.2168 6.58472C7.21194 6.61694 7.20866 6.64262 7.20605 6.65991C7.20477 6.66845 7.20282 6.67498 7.20215 6.67944V6.68628H7.20117C7.18528 6.79233 7.12718 6.89009 7.05273 6.96362C6.97829 7.03714 6.87987 7.09441 6.77344 7.10913L6.77246 7.10815C6.71344 7.11648 6.14426 7.19577 5.58203 7.27319C5.28505 7.31409 4.98821 7.35485 4.76562 7.3855C4.65455 7.40079 4.56197 7.41367 4.49707 7.42261C4.46461 7.42708 4.43829 7.43096 4.4209 7.43335C4.41242 7.43452 4.40578 7.43567 4.40137 7.43628C4.39929 7.43657 4.3976 7.43613 4.39648 7.43628L4.39551 7.43726C4.25198 7.45753 4.10882 7.40699 4.00488 7.31323C4.00677 7.31462 4.00843 7.3163 4.00977 7.31714C4.01097 7.31789 4.01197 7.31869 4.0127 7.31909C4.01145 7.31844 4.00717 7.3159 4.00293 7.31323C3.99768 7.3099 3.99067 7.30484 3.9834 7.29761L3.98242 7.29663L1.78125 5.06616L1.36426 5.47827C1.4144 5.85361 1.54631 6.66001 1.84082 7.51245C2.14964 8.40621 2.63132 9.33508 3.36816 9.87866C3.97445 10.326 4.67397 10.4596 5.51855 10.2781L5.52441 10.2761L7.91113 9.89429Z'
        fill='black'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M16.8096 13.9167C16.9036 13.9105 16.9995 13.9337 17.0869 13.9919L17.1709 14.0613L17.1738 14.0642C17.1755 14.0659 17.1776 14.0689 17.1807 14.072C17.1869 14.0783 17.1965 14.0868 17.208 14.0984C17.2311 14.1218 17.2645 14.1563 17.3066 14.199C17.391 14.2844 17.5105 14.4059 17.6533 14.5505C17.9393 14.8402 18.3192 15.2242 18.6982 15.6082C19.0775 15.9923 19.4563 16.3763 19.7402 16.6638C19.8821 16.8076 20.0003 16.9277 20.083 17.0115C20.1223 17.0513 20.1538 17.0829 20.1758 17.1052L22.2969 16.7673C23.3836 16.5352 24.3712 16.7248 25.2051 17.3406C26.2478 18.1111 26.8473 19.4095 27.1885 20.5203C27.5306 21.6343 27.6187 22.5784 27.626 22.658L27.6221 22.7634C27.6117 22.8336 27.5864 22.9035 27.5488 22.9636L27.4834 23.0457C27.473 23.0559 27.2437 23.2824 27.0156 23.5076C26.8995 23.6222 26.7832 23.7372 26.6963 23.823C26.6528 23.8659 26.6162 23.9015 26.5908 23.9265L26.5518 23.9656C26.3616 24.1535 26.0523 24.1524 25.8643 23.9617L23.4922 21.5583L21.7012 21.8054L21.4316 23.5925L23.8027 25.9939C23.9893 26.1816 23.9872 26.4961 23.7998 26.6814L22.8682 27.6023L22.8643 27.6062C22.7754 27.6847 22.6529 27.7419 22.5273 27.7419L22.4785 27.74C22.399 27.732 21.4569 27.6315 20.3477 27.2751C19.2415 26.9198 17.9502 26.3034 17.1934 25.2507C16.587 24.4078 16.4112 23.4151 16.6631 22.3103L17.0244 20.2195L14.0107 17.1677C13.9029 17.0585 13.86 16.9296 13.8701 16.8044C13.88 16.6821 13.94 16.5707 14.0234 16.489C14.107 16.4073 14.2196 16.3497 14.3418 16.3416C14.4667 16.3333 14.5952 16.3769 14.7021 16.4851L16.3047 18.1082C16.702 18.5106 17.0991 18.9124 17.3965 19.2136C17.5451 19.3641 17.6692 19.4901 17.7559 19.5779C17.799 19.6216 17.8333 19.656 17.8564 19.6794L17.8896 19.7126L17.8906 19.7146C18.0009 19.826 18.0514 19.985 18.0244 20.1394L17.6152 22.5007L17.6143 22.5056C17.4175 23.3693 17.5423 24.0714 17.9824 24.6833C18.5182 25.4283 19.4401 25.9221 20.3291 26.2419C21.1772 26.547 21.9813 26.6874 22.3555 26.7419L22.7715 26.3308L20.5703 24.1013C20.5183 24.0487 20.4808 23.979 20.458 23.9089C20.4353 23.8388 20.4254 23.7602 20.4365 23.6873C20.4404 23.6612 20.5286 23.0772 20.6162 22.4958C20.6608 22.1999 20.7049 21.904 20.7383 21.6824C20.755 21.5717 20.7696 21.4794 20.7793 21.4148C20.7842 21.3825 20.7874 21.3569 20.79 21.3396C20.7913 21.3312 20.7923 21.3245 20.793 21.3201C20.7933 21.3181 20.7938 21.3163 20.7939 21.3152V21.3132C20.81 21.2065 20.8678 21.1086 20.9424 21.0349C21.017 20.9612 21.1157 20.9043 21.2227 20.8894H21.2256C21.2256 20.8894 21.8167 20.8075 22.4131 20.7253C22.7099 20.6844 23.0069 20.6437 23.2295 20.613C23.3408 20.5977 23.4341 20.5849 23.499 20.5759C23.5313 20.5715 23.5568 20.5686 23.5742 20.5662C23.5826 20.565 23.5893 20.5639 23.5938 20.5632C23.596 20.5629 23.5985 20.5624 23.5996 20.5623H23.6016C23.621 20.5597 23.6372 20.5624 23.6426 20.5632H23.6377C23.7698 20.5547 23.9159 20.6038 24.0127 20.7019L25.1533 21.8582C25.4364 22.1449 25.7197 22.4306 25.9316 22.6453C26.0376 22.7526 26.1257 22.8424 26.1875 22.905C26.197 22.9147 26.2056 22.924 26.2139 22.9324L26.6309 22.5203C26.5806 22.1445 26.4495 21.3387 26.1553 20.4871C25.8465 19.5933 25.3647 18.6644 24.6279 18.1208C24.0217 17.6735 23.3218 17.5407 22.4766 17.7214L22.4707 17.7224L20.084 18.1052C19.9291 18.13 19.7712 18.0783 19.6611 17.9666L16.4795 14.7429C16.372 14.634 16.329 14.5056 16.3389 14.3806C16.3486 14.2582 16.4079 14.1463 16.4912 14.0642C16.5745 13.9822 16.6871 13.9249 16.8096 13.9167Z'
        fill='black'
        stroke='black'
        strokeWidth='0.2'
      />
      <path
        d='M19.4346 20.9087L19.4355 20.9097C19.6973 20.9659 19.8652 21.2234 19.8096 21.4858L19.5322 22.7993C19.4845 23.0272 19.2781 23.1822 19.0586 23.1841C18.7549 23.1869 18.5204 22.8896 18.5811 22.5981L18.582 22.5942L18.7207 21.9399C18.7554 21.7759 18.7904 21.6117 18.8164 21.4888C18.8294 21.4274 18.8401 21.3761 18.8477 21.3403C18.8514 21.3224 18.8544 21.3079 18.8564 21.2983C18.8574 21.2937 18.8579 21.29 18.8584 21.2876L18.8594 21.2847V21.2837C18.9083 21.054 19.113 20.9002 19.3369 20.8999L19.4346 20.9087Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M22.5381 18.8113C22.6889 18.7846 22.8194 18.8223 22.917 18.9011C23.0125 18.9784 23.0712 19.0908 23.0918 19.2058C23.1124 19.3208 23.0963 19.4461 23.0342 19.5515C22.9707 19.6592 22.8624 19.7399 22.7129 19.7673H22.7109C22.7096 19.7676 22.6901 19.7715 22.6543 19.7781C22.6178 19.7847 22.5659 19.7941 22.5039 19.8054L21.5977 19.9714C21.5359 19.9827 21.4842 19.9922 21.4482 19.9988C21.4303 20.0021 21.4159 20.0048 21.4062 20.0066C21.4016 20.0074 21.3979 20.0081 21.3955 20.0085L21.3926 20.0095H21.3906C21.3624 20.0142 21.3332 20.0173 21.3037 20.0173C21.0122 20.0173 20.8513 19.7946 20.832 19.574C20.813 19.3539 20.9326 19.1053 21.2168 19.0535H21.2178C21.2185 19.0533 21.2195 19.0527 21.2207 19.0525C21.2233 19.052 21.2275 19.0514 21.2324 19.0505C21.2423 19.0487 21.2564 19.046 21.2744 19.0427C21.3108 19.0361 21.3629 19.0267 21.4248 19.0154C21.5489 18.9927 21.7141 18.9626 21.8789 18.9324C22.0437 18.9022 22.2086 18.872 22.332 18.8494C22.3934 18.8381 22.4445 18.8286 22.4805 18.822C22.4983 18.8187 22.5128 18.816 22.5225 18.8142C22.5273 18.8133 22.5317 18.8127 22.5342 18.8123H22.5371L22.5381 18.8113Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M8.94336 4.73633C9.05912 4.7524 9.17368 4.80662 9.25488 4.89844C9.33767 4.99228 9.38074 5.12057 9.36035 5.27148C9.35851 5.2851 9.31386 5.61299 9.26953 5.93945C9.24701 6.10531 9.22487 6.27132 9.20801 6.39551C9.19962 6.4573 9.19241 6.50878 9.1875 6.54492C9.18507 6.5628 9.18296 6.57722 9.18164 6.58691C9.18098 6.59176 9.181 6.59613 9.18066 6.59863L9.17969 6.60156C9.1592 6.75331 9.08373 6.86632 8.97852 6.93457C8.87554 7.0013 8.75051 7.02196 8.63477 7.00586C8.51907 6.98973 8.40444 6.93537 8.32324 6.84375C8.24049 6.7501 8.19736 6.62224 8.21777 6.47168L8.39844 5.14062C8.41897 4.98878 8.49441 4.87602 8.59961 4.80762C8.70257 4.74067 8.82754 4.72028 8.94336 4.73633Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
      <path
        d='M6.79102 8.06738C6.94165 8.03989 7.0725 8.07712 7.16992 8.15625C7.26512 8.23358 7.32327 8.34584 7.34375 8.46094C7.36419 8.57609 7.34852 8.70195 7.28613 8.80762C7.22234 8.9156 7.1132 8.99641 6.96289 9.02344H6.95996C6.95547 9.02425 6.87577 9.03869 6.75391 9.06055C6.62975 9.08282 6.46465 9.11299 6.2998 9.14258C6.13495 9.17216 5.97014 9.20147 5.84668 9.22363C5.78497 9.23471 5.73325 9.24354 5.69727 9.25C5.67966 9.25316 5.66584 9.25609 5.65625 9.25781C5.65143 9.25868 5.64702 9.25932 5.64453 9.25977L5.6416 9.26074H5.64062C5.61298 9.26553 5.58385 9.26855 5.55469 9.26855C5.26292 9.26834 5.10116 9.04528 5.08203 8.82422C5.06298 8.60391 5.18312 8.35695 5.46777 8.30469L6.13379 8.18555C6.29841 8.15602 6.46264 8.12563 6.58594 8.10352C6.64764 8.09245 6.69938 8.0836 6.73535 8.07715C6.75328 8.07393 6.76773 8.07106 6.77734 8.06934C6.78196 8.06851 6.78567 8.06782 6.78809 8.06738H6.79102Z'
        fill='#00C1D5'
        stroke='#00C1D5'
        strokeWidth='0.2'
      />
    </svg>
  )
}
export const Policy3 = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.0794 23.9154C13.1983 23.9818 13.3322 24.0166 13.4683 24.0166C13.6044 24.0166 13.7383 23.9818 13.8572 23.9154L21.8602 19.2948C21.9784 19.2265 22.0766 19.1284 22.1449 19.0102C22.2131 18.8919 22.2491 18.7578 22.249 18.6213V9.37905C22.2469 9.24297 22.2101 9.1097 22.142 8.99184C22.074 8.87399 21.977 8.77546 21.8602 8.70559L13.8572 4.08492C13.7389 4.01677 13.6048 3.9809 13.4683 3.9809C13.3318 3.9809 13.1977 4.01677 13.0794 4.08492L5.07609 8.70559C4.95936 8.77552 4.8624 8.87406 4.79435 8.9919C4.72631 9.10974 4.68944 9.24299 4.68722 9.37905V18.6213C4.68725 18.7578 4.72319 18.8919 4.79145 19.0101C4.85971 19.1284 4.95787 19.2265 5.07609 19.2948L13.0794 23.9154ZM20.6936 18.1722L14.246 21.8946V14.4491L18.0791 12.2358L18.0834 12.2333L20.6936 10.7261V18.1722ZM13.4683 5.65672L19.9159 9.37915L17.6979 10.6599L11.2505 6.93691L13.4683 5.65672ZM9.69519 7.83494L16.1428 11.5579L13.4685 13.102L7.02071 9.37905L9.69519 7.83494ZM6.24267 10.7261L12.6906 14.4491V21.8946L6.24267 18.1722V10.7261ZM10.4229 14.1981L8.64853 13.1737C8.56002 13.1208 8.46188 13.0861 8.35982 13.0715C8.25776 13.0569 8.15382 13.0628 8.05404 13.0887C7.95426 13.1146 7.86064 13.1602 7.77861 13.2226C7.69659 13.2851 7.6278 13.3632 7.57624 13.4525C7.52469 13.5418 7.4914 13.6405 7.47831 13.7427C7.46523 13.845 7.4726 13.9489 7.50001 14.0482C7.52742 14.1476 7.57432 14.2406 7.63798 14.3217C7.70163 14.4028 7.78078 14.4704 7.87081 14.5207L9.64521 15.5454C9.73372 15.5982 9.83186 15.633 9.93392 15.6476C10.036 15.6622 10.1399 15.6563 10.2397 15.6304C10.3395 15.6044 10.4331 15.5589 10.5151 15.4965C10.5972 15.434 10.6659 15.3559 10.7175 15.2666C10.7691 15.1773 10.8023 15.0786 10.8154 14.9764C10.8285 14.8741 10.8211 14.7702 10.7937 14.6708C10.7663 14.5714 10.7194 14.4785 10.6558 14.3974C10.5921 14.3163 10.513 14.2483 10.4229 14.1981ZM25.5351 21.5385C25.4986 21.3597 25.4028 21.1984 25.2632 21.0809C25.1236 20.9633 24.9484 20.8963 24.766 20.8908L21.8057 20.8999C21.7036 20.9001 21.6025 20.9203 21.5082 20.9596C21.4139 20.9988 21.3283 21.0562 21.2561 21.1285C21.1105 21.2746 21.0289 21.4726 21.0292 21.6788C21.0295 21.8851 21.1117 22.0828 21.2578 22.2285C21.4038 22.3741 21.6018 22.4558 21.808 22.4555H21.8103L23.1313 22.4514C21.0278 24.7233 18.153 26.1293 15.0684 26.3949C11.9838 26.6604 8.91103 25.7664 6.45025 23.8875C3.98947 22.0086 2.31746 19.2798 1.76081 16.234C1.20416 13.1882 1.80286 10.0443 3.43996 7.41633C3.49409 7.32972 3.53063 7.23329 3.5475 7.13255C3.56437 7.03181 3.56123 6.92874 3.53826 6.82921C3.5153 6.72969 3.47296 6.63566 3.41365 6.5525C3.35435 6.46934 3.27926 6.39868 3.19265 6.34455C3.10604 6.29041 3.00962 6.25387 2.90889 6.237C2.80816 6.22013 2.70509 6.22327 2.60558 6.24624C2.50606 6.26921 2.41204 6.31155 2.32889 6.37086C2.24573 6.43016 2.17508 6.50527 2.12095 6.59188C0.276154 9.54987 -0.398694 13.0898 0.228431 16.5191C0.855556 19.9484 2.73953 23.0203 5.51176 25.1338C8.28399 27.2474 11.745 28.2504 15.2177 27.9468C18.6903 27.6431 21.9247 26.0546 24.2881 23.492L24.5028 24.7601C24.5336 24.941 24.6273 25.1053 24.7675 25.2239C24.9076 25.3424 25.0852 25.4075 25.2688 25.4077C25.3127 25.4077 25.3565 25.404 25.3997 25.3965C25.5004 25.3795 25.5968 25.3428 25.6833 25.2885C25.7698 25.2342 25.8448 25.1634 25.9039 25.0801C25.9631 24.9968 26.0052 24.9027 26.028 24.8031C26.0508 24.7036 26.0537 24.6005 26.0367 24.4998L25.5351 21.5385ZM14.0014 4.90781e-05C10.879 -0.00825076 7.845 1.03639 5.38946 2.96522L5.39288 1.72932C5.39314 1.62716 5.37328 1.52595 5.33443 1.43147C5.29557 1.33698 5.23849 1.25108 5.16643 1.17866C5.09437 1.10625 5.00875 1.04874 4.91447 1.00942C4.82018 0.970104 4.71907 0.949748 4.61692 0.949517H4.6149C4.40899 0.949517 4.21149 1.03118 4.06569 1.17659C3.9199 1.32201 3.83772 1.51931 3.83717 1.72523L3.82908 4.68652C3.83254 4.87298 3.90122 5.05233 4.02318 5.19341C4.14515 5.33448 4.31269 5.42835 4.49668 5.4587L7.4569 5.88207C7.49375 5.88707 7.53089 5.8896 7.56807 5.88965C7.765 5.88981 7.95465 5.81525 8.09876 5.68102C8.24287 5.5468 8.33069 5.36289 8.34451 5.16644C8.35833 4.96998 8.29711 4.77559 8.17321 4.62251C8.04931 4.46943 7.87196 4.36906 7.67695 4.34165L6.38878 4.15773C8.57279 2.47036 11.2556 1.55678 14.0155 1.56066C16.7753 1.56453 19.4556 2.48562 21.6348 4.17911C23.8141 5.8726 25.3688 8.24243 26.0544 10.916C26.74 13.5895 26.5176 16.4151 25.4223 18.9485C25.3796 19.0425 25.3561 19.144 25.3531 19.2472C25.3501 19.3504 25.3677 19.4532 25.4048 19.5495C25.4419 19.6458 25.4979 19.7338 25.5693 19.8083C25.6408 19.8828 25.7264 19.9423 25.8211 19.9834C25.9158 20.0245 26.0178 20.0463 26.121 20.0475C26.2242 20.0488 26.3266 20.0295 26.4223 19.9907C26.518 19.952 26.605 19.8946 26.6783 19.8219C26.7516 19.7492 26.8097 19.6626 26.8491 19.5672C27.7705 17.4367 28.148 15.1106 27.9477 12.7981C27.7474 10.4855 26.9756 8.25897 25.7016 6.31867C24.4276 4.37837 22.6914 2.78513 20.6491 1.6822C18.6068 0.579267 16.3225 0.00122638 14.0014 4.90781e-05Z'
        fill='black'
      />
      <line
        x1='7.87207'
        y1='13.7093'
        x2='10.7093'
        y2='15.1279'
        stroke='#00C1D5'
        strokeWidth='1.3'
        strokeLinecap='round'
      />
      <path d='M10 6L8 7L17.5 12.5L19 11.5L10 6Z' fill='#00C1D5' />
    </svg>
  )
}
